/* eslint-disable */
// @ts-nocheck

"use client";

import type {
  Message as __bufbuildProtobufMessage,
  MessageType as __bufbuildProtobufMessageType,
  PartialMessage as __bufbuildProtobufPartialMessage,
} from "@bufbuild/protobuf";
import {
  Empty
} from "@bufbuild/protobuf";
import * as reboot_react from "@reboot-dev/reboot-react";
import * as reboot_web from "@reboot-dev/reboot-web";
import * as reboot_api from "@reboot-dev/reboot-api";
import {
  useEffect,
  useMemo,
  useState,
} from "react";
import { unstable_batchedUpdates } from "react-dom";
import { v4 as uuidv4 } from "uuid";
// NOTE NOTE NOTE
//
// If you are reading this comment because you are trying to debug
// the error:
//
// Module not found: Error: Can't resolve './copenhunt_pb.js'
//
// You can resolve this by passing --react-extensions to `rbt
// protoc` (or better put it in your `.rbtrc` file).
//
// This is a known issue if you're using `webpack` which uses
// `ts-loader` (https://github.com/TypeStrong/ts-loader/issues/465).
import {
  Event,
  HealthCheckResponse,
  UpdateCoordinatesRequest,
  UpdateCoordinatesResponse,
  LocationSetRequest,
  LocationReleaseToTeamRequest,
  LocationReleaseToTeamResponse,
  GameCreateRequest,
  GameCreateResponse,
  GameCountdownRequest,
  GameAddChatIdsRequest,
  GameTeamChatIdsResponse,
  GameOverviewRequest,
  GameOverviewResponse,
  GameSendChatRequest,
  GameBroadcastRequest,
  GameDeletePlayerRequest,
  GameRemoveObjectiveRequest,
  GameDeleteLocationRequest,
  GameDeleteTeamRequest,
  PlayerInfo,
  PlayersRequest,
  PlayersResponse,
  PlayerCreateRequest,
  PlayerCreateResponse,
  PlayerAddCoordinatesRequest,
  PlayerAddCoordinatesResponse,
  PlayerCurrentCoordinatesRequest,
  PlayerCurrentCoordinatesResponse,
  PlayerNameRequest,
  PlayerNameResponse,
  PlayerTeamRequest,
  PlayerTeamResponse,
  PlayerVisibleInfoRequest,
  PlayerVisibleInfoResponse,
  PlayerCoordinates,
  TeamCreateRequest,
  TeamCreateResponse,
  TeamJoinRequest,
  TeamJoinResponse,
  TeamInfoRequest,
  TeamInfoResponse,
  TeamRoleResponse,
  TeamAddChatIdRequest,
  TeamDeletePlayerRequest,
  TeamGrabObjectiveRequest,
  TeamCurrentObjectiveResponse,
  TeamRemoveObjectiveRequest,
  TeamSetExtraPingsRequest,
  Coordinates,
  LocationInfo,
  PlayerLocationInfo,
  GameUpdateSettingsRequest,
  GameMode,
  GameCondition,
  Game as GameProto,
  Team as TeamProto,
  Player as PlayerProto,
  Location as LocationProto,
} from "./copenhunt_pb";

// Additionally re-export all messages_and_enums from the pb module.
export {
  Event,
  HealthCheckResponse,
  UpdateCoordinatesRequest,
  UpdateCoordinatesResponse,
  LocationSetRequest,
  LocationReleaseToTeamRequest,
  LocationReleaseToTeamResponse,
  GameCreateRequest,
  GameCreateResponse,
  GameCountdownRequest,
  GameAddChatIdsRequest,
  GameTeamChatIdsResponse,
  GameOverviewRequest,
  GameOverviewResponse,
  GameSendChatRequest,
  GameBroadcastRequest,
  GameDeletePlayerRequest,
  GameRemoveObjectiveRequest,
  GameDeleteLocationRequest,
  GameDeleteTeamRequest,
  PlayerInfo,
  PlayersRequest,
  PlayersResponse,
  PlayerCreateRequest,
  PlayerCreateResponse,
  PlayerAddCoordinatesRequest,
  PlayerAddCoordinatesResponse,
  PlayerCurrentCoordinatesRequest,
  PlayerCurrentCoordinatesResponse,
  PlayerNameRequest,
  PlayerNameResponse,
  PlayerTeamRequest,
  PlayerTeamResponse,
  PlayerVisibleInfoRequest,
  PlayerVisibleInfoResponse,
  PlayerCoordinates,
  TeamCreateRequest,
  TeamCreateResponse,
  TeamJoinRequest,
  TeamJoinResponse,
  TeamInfoRequest,
  TeamInfoResponse,
  TeamRoleResponse,
  TeamAddChatIdRequest,
  TeamDeletePlayerRequest,
  TeamGrabObjectiveRequest,
  TeamCurrentObjectiveResponse,
  TeamRemoveObjectiveRequest,
  TeamSetExtraPingsRequest,
  Coordinates,
  LocationInfo,
  PlayerLocationInfo,
  GameUpdateSettingsRequest,
  GameMode,
  GameCondition,
};

export type PendingGameCreateRequestMutation = reboot_react.Mutation<GameCreateRequest>;
export type PendingEmptyMutation = reboot_react.Mutation<Empty>;
export type PendingGameCountdownRequestMutation = reboot_react.Mutation<GameCountdownRequest>;
export type PendingLocationInfoMutation = reboot_react.Mutation<LocationInfo>;
export type PendingGameAddChatIdsRequestMutation = reboot_react.Mutation<GameAddChatIdsRequest>;
export type PendingGameBroadcastRequestMutation = reboot_react.Mutation<GameBroadcastRequest>;
export type PendingGameDeletePlayerRequestMutation = reboot_react.Mutation<GameDeletePlayerRequest>;
export type PendingGameRemoveObjectiveRequestMutation = reboot_react.Mutation<GameRemoveObjectiveRequest>;
export type PendingGameUpdateSettingsRequestMutation = reboot_react.Mutation<GameUpdateSettingsRequest>;
export type PendingGameDeleteTeamRequestMutation = reboot_react.Mutation<GameDeleteTeamRequest>;
export type PendingGameDeleteLocationRequestMutation = reboot_react.Mutation<GameDeleteLocationRequest>;
export type PendingTeamCreateRequestMutation = reboot_react.Mutation<TeamCreateRequest>;
export type PendingTeamJoinRequestMutation = reboot_react.Mutation<TeamJoinRequest>;
export type PendingTeamAddChatIdRequestMutation = reboot_react.Mutation<TeamAddChatIdRequest>;
export type PendingTeamDeletePlayerRequestMutation = reboot_react.Mutation<TeamDeletePlayerRequest>;
export type PendingTeamGrabObjectiveRequestMutation = reboot_react.Mutation<TeamGrabObjectiveRequest>;
export type PendingTeamRemoveObjectiveRequestMutation = reboot_react.Mutation<TeamRemoveObjectiveRequest>;
export type PendingTeamSetExtraPingsRequestMutation = reboot_react.Mutation<TeamSetExtraPingsRequest>;
export type PendingPlayerCreateRequestMutation = reboot_react.Mutation<PlayerCreateRequest>;
export type PendingPlayerAddCoordinatesRequestMutation = reboot_react.Mutation<PlayerAddCoordinatesRequest>;
export type PendingLocationSetRequestMutation = reboot_react.Mutation<LocationSetRequest>;
export type PendingLocationReleaseToTeamRequestMutation = reboot_react.Mutation<LocationReleaseToTeamRequest>;



const ERROR_TYPES = [
  // gRPC errors.
  reboot_api.errors_pb.Cancelled,
  reboot_api.errors_pb.Unknown,
  reboot_api.errors_pb.InvalidArgument,
  reboot_api.errors_pb.DeadlineExceeded,
  reboot_api.errors_pb.NotFound,
  reboot_api.errors_pb.AlreadyExists,
  reboot_api.errors_pb.PermissionDenied,
  reboot_api.errors_pb.ResourceExhausted,
  reboot_api.errors_pb.FailedPrecondition,
  reboot_api.errors_pb.Aborted,
  reboot_api.errors_pb.OutOfRange,
  reboot_api.errors_pb.Unimplemented,
  reboot_api.errors_pb.Internal,
  reboot_api.errors_pb.Unavailable,
  reboot_api.errors_pb.DataLoss,
  reboot_api.errors_pb.Unauthenticated,
  // Reboot errors.
  //
  // NOTE: also add any new errors into `rbt/v1alpha1/index.ts`.
  reboot_api.errors_pb.StateAlreadyConstructed,
  reboot_api.errors_pb.StateNotConstructed,
  reboot_api.errors_pb.TransactionParticipantFailedToPrepare,
  reboot_api.errors_pb.TransactionParticipantFailedToCommit,
  reboot_api.errors_pb.UnknownService,
  reboot_api.errors_pb.UnknownTask,
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export interface GameMutators {
  create: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameCreateRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        GameCreateResponse,
        GameCreateAborted
      >>;

    pending: PendingGameCreateRequestMutation[];
  };
  start: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameStartAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  pause: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GamePauseAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  unpause: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameUnpauseAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  countdown: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameCountdownRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameCountdownAborted
      >>;

    pending: PendingGameCountdownRequestMutation[];
  };
  addLocation: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<LocationInfo>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameAddLocationAborted
      >>;

    pending: PendingLocationInfoMutation[];
  };
  releaseLocations: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameReleaseLocationsAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  addChatIds: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameAddChatIdsRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameAddChatIdsAborted
      >>;

    pending: PendingGameAddChatIdsRequestMutation[];
  };
  broadcast: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameBroadcastRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameBroadcastAborted
      >>;

    pending: PendingGameBroadcastRequestMutation[];
  };
  deletePlayer: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameDeletePlayerRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameDeletePlayerAborted
      >>;

    pending: PendingGameDeletePlayerRequestMutation[];
  };
  removeObjective: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameRemoveObjectiveRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameRemoveObjectiveAborted
      >>;

    pending: PendingGameRemoveObjectiveRequestMutation[];
  };
  sendPing: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameSendPingAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  updateSettings: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameUpdateSettingsRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameUpdateSettingsAborted
      >>;

    pending: PendingGameUpdateSettingsRequestMutation[];
  };
  deleteTeam: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameDeleteTeamRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameDeleteTeamAborted
      >>;

    pending: PendingGameDeleteTeamRequestMutation[];
  };
  deleteLocation: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameDeleteLocationRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameDeleteLocationAborted
      >>;

    pending: PendingGameDeleteLocationRequestMutation[];
  };
}

const GAME_CREATE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameCreateAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_CREATE_ERROR_TYPES
  >[number];

export class GameCreateAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_CREATE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameCreateAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameCreateAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameCreateAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameCreateAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_OVERVIEW_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameOverviewAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_OVERVIEW_ERROR_TYPES
  >[number];

export class GameOverviewAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_OVERVIEW_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameOverviewAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameOverviewAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameOverviewAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameOverviewAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_START_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameStartAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_START_ERROR_TYPES
  >[number];

export class GameStartAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_START_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameStartAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameStartAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameStartAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameStartAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_PAUSE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GamePauseAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_PAUSE_ERROR_TYPES
  >[number];

export class GamePauseAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_PAUSE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GamePauseAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GamePauseAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GamePauseAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GamePauseAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_UNPAUSE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameUnpauseAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_UNPAUSE_ERROR_TYPES
  >[number];

export class GameUnpauseAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_UNPAUSE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameUnpauseAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameUnpauseAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameUnpauseAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameUnpauseAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_COUNTDOWN_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameCountdownAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_COUNTDOWN_ERROR_TYPES
  >[number];

export class GameCountdownAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_COUNTDOWN_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameCountdownAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameCountdownAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameCountdownAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameCountdownAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_ADD_LOCATION_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameAddLocationAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_ADD_LOCATION_ERROR_TYPES
  >[number];

export class GameAddLocationAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_ADD_LOCATION_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameAddLocationAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameAddLocationAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameAddLocationAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameAddLocationAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_RELEASE_LOCATIONS_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameReleaseLocationsAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_RELEASE_LOCATIONS_ERROR_TYPES
  >[number];

export class GameReleaseLocationsAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_RELEASE_LOCATIONS_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameReleaseLocationsAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameReleaseLocationsAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameReleaseLocationsAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameReleaseLocationsAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_ADD_CHAT_IDS_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameAddChatIdsAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_ADD_CHAT_IDS_ERROR_TYPES
  >[number];

export class GameAddChatIdsAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_ADD_CHAT_IDS_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameAddChatIdsAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameAddChatIdsAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameAddChatIdsAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameAddChatIdsAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_TEAM_CHAT_IDS_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameTeamChatIdsAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_TEAM_CHAT_IDS_ERROR_TYPES
  >[number];

export class GameTeamChatIdsAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_TEAM_CHAT_IDS_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameTeamChatIdsAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameTeamChatIdsAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameTeamChatIdsAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameTeamChatIdsAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_SEND_CHAT_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameSendChatAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_SEND_CHAT_ERROR_TYPES
  >[number];

export class GameSendChatAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_SEND_CHAT_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameSendChatAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameSendChatAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameSendChatAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameSendChatAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_BROADCAST_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameBroadcastAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_BROADCAST_ERROR_TYPES
  >[number];

export class GameBroadcastAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_BROADCAST_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameBroadcastAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameBroadcastAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameBroadcastAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameBroadcastAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_DELETE_PLAYER_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameDeletePlayerAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_DELETE_PLAYER_ERROR_TYPES
  >[number];

export class GameDeletePlayerAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_DELETE_PLAYER_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameDeletePlayerAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameDeletePlayerAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameDeletePlayerAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameDeletePlayerAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_CHECK_FOR_OBJECTIVES_GRABBED_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameCheckForObjectivesGrabbedAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_CHECK_FOR_OBJECTIVES_GRABBED_ERROR_TYPES
  >[number];

export class GameCheckForObjectivesGrabbedAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_CHECK_FOR_OBJECTIVES_GRABBED_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameCheckForObjectivesGrabbedAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameCheckForObjectivesGrabbedAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameCheckForObjectivesGrabbedAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameCheckForObjectivesGrabbedAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_REMOVE_OBJECTIVE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameRemoveObjectiveAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_REMOVE_OBJECTIVE_ERROR_TYPES
  >[number];

export class GameRemoveObjectiveAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_REMOVE_OBJECTIVE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameRemoveObjectiveAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameRemoveObjectiveAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameRemoveObjectiveAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameRemoveObjectiveAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_SEND_PING_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameSendPingAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_SEND_PING_ERROR_TYPES
  >[number];

export class GameSendPingAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_SEND_PING_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameSendPingAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameSendPingAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameSendPingAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameSendPingAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_UPDATE_SETTINGS_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameUpdateSettingsAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_UPDATE_SETTINGS_ERROR_TYPES
  >[number];

export class GameUpdateSettingsAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_UPDATE_SETTINGS_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameUpdateSettingsAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameUpdateSettingsAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameUpdateSettingsAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameUpdateSettingsAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_DELETE_TEAM_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameDeleteTeamAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_DELETE_TEAM_ERROR_TYPES
  >[number];

export class GameDeleteTeamAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_DELETE_TEAM_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameDeleteTeamAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameDeleteTeamAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameDeleteTeamAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameDeleteTeamAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const GAME_DELETE_LOCATION_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type GameDeleteLocationAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof GAME_DELETE_LOCATION_ERROR_TYPES
  >[number];

export class GameDeleteLocationAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      GAME_DELETE_LOCATION_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new GameDeleteLocationAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new GameDeleteLocationAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: GameDeleteLocationAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: GameDeleteLocationAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}


export interface UseGameApi {
  mutators: GameMutators;
  create: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameCreateRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        GameCreateResponse,
        GameCreateAborted
      >>;

    pending: PendingGameCreateRequestMutation[];
  };
  useOverview: (
    partialRequest?: __bufbuildProtobufPartialMessage<GameOverviewRequest>
  ) => {
    response: GameOverviewResponse | undefined;
    isLoading: boolean;
    aborted: undefined | GameOverviewAborted;
  };
  overview: (
    partialRequest?: __bufbuildProtobufPartialMessage<GameOverviewRequest>,
    options?: { signal?: AbortSignal }
  ) => Promise<
    reboot_web.ResponseOrAborted<
    GameOverviewResponse,
    GameOverviewAborted
    >
  >;
  start: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameStartAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  pause: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GamePauseAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  unpause: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameUnpauseAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  countdown: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameCountdownRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameCountdownAborted
      >>;

    pending: PendingGameCountdownRequestMutation[];
  };
  addLocation: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<LocationInfo>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameAddLocationAborted
      >>;

    pending: PendingLocationInfoMutation[];
  };
  releaseLocations: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameReleaseLocationsAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  addChatIds: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameAddChatIdsRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameAddChatIdsAborted
      >>;

    pending: PendingGameAddChatIdsRequestMutation[];
  };
  useTeamChatIds: (
    partialRequest?: __bufbuildProtobufPartialMessage<Empty>
  ) => {
    response: GameTeamChatIdsResponse | undefined;
    isLoading: boolean;
    aborted: undefined | GameTeamChatIdsAborted;
  };
  teamChatIds: (
    partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
    options?: { signal?: AbortSignal }
  ) => Promise<
    reboot_web.ResponseOrAborted<
    GameTeamChatIdsResponse,
    GameTeamChatIdsAborted
    >
  >;
  broadcast: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameBroadcastRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameBroadcastAborted
      >>;

    pending: PendingGameBroadcastRequestMutation[];
  };
  deletePlayer: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameDeletePlayerRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameDeletePlayerAborted
      >>;

    pending: PendingGameDeletePlayerRequestMutation[];
  };
  removeObjective: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameRemoveObjectiveRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameRemoveObjectiveAborted
      >>;

    pending: PendingGameRemoveObjectiveRequestMutation[];
  };
  sendPing: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameSendPingAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  updateSettings: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameUpdateSettingsRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameUpdateSettingsAborted
      >>;

    pending: PendingGameUpdateSettingsRequestMutation[];
  };
  deleteTeam: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameDeleteTeamRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameDeleteTeamAborted
      >>;

    pending: PendingGameDeleteTeamRequestMutation[];
  };
  deleteLocation: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<GameDeleteLocationRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameDeleteLocationAborted
      >>;

    pending: PendingGameDeleteLocationRequestMutation[];
  };
}
export interface TeamMutators {
  create: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamCreateRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        TeamCreateResponse,
        TeamCreateAborted
      >>;

    pending: PendingTeamCreateRequestMutation[];
  };
  join: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamJoinRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        TeamJoinResponse,
        TeamJoinAborted
      >>;

    pending: PendingTeamJoinRequestMutation[];
  };
  addChatId: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamAddChatIdRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamAddChatIdAborted
      >>;

    pending: PendingTeamAddChatIdRequestMutation[];
  };
  deletePlayer: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamDeletePlayerRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamDeletePlayerAborted
      >>;

    pending: PendingTeamDeletePlayerRequestMutation[];
  };
  grabObjective: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamGrabObjectiveRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamGrabObjectiveAborted
      >>;

    pending: PendingTeamGrabObjectiveRequestMutation[];
  };
  removeObjective: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamRemoveObjectiveRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamRemoveObjectiveAborted
      >>;

    pending: PendingTeamRemoveObjectiveRequestMutation[];
  };
  sendPing: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamSendPingAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  setExtraPings: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamSetExtraPingsRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamSetExtraPingsAborted
      >>;

    pending: PendingTeamSetExtraPingsRequestMutation[];
  };
}

const TEAM_CREATE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type TeamCreateAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof TEAM_CREATE_ERROR_TYPES
  >[number];

export class TeamCreateAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      TEAM_CREATE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new TeamCreateAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new TeamCreateAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: TeamCreateAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: TeamCreateAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const TEAM_JOIN_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type TeamJoinAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof TEAM_JOIN_ERROR_TYPES
  >[number];

export class TeamJoinAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      TEAM_JOIN_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new TeamJoinAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new TeamJoinAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: TeamJoinAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: TeamJoinAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const TEAM_PLAYERS_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type TeamPlayersAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof TEAM_PLAYERS_ERROR_TYPES
  >[number];

export class TeamPlayersAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      TEAM_PLAYERS_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new TeamPlayersAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new TeamPlayersAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: TeamPlayersAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: TeamPlayersAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const TEAM_INFO_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type TeamInfoAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof TEAM_INFO_ERROR_TYPES
  >[number];

export class TeamInfoAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      TEAM_INFO_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new TeamInfoAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new TeamInfoAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: TeamInfoAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: TeamInfoAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const TEAM_ADD_CHAT_ID_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type TeamAddChatIdAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof TEAM_ADD_CHAT_ID_ERROR_TYPES
  >[number];

export class TeamAddChatIdAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      TEAM_ADD_CHAT_ID_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new TeamAddChatIdAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new TeamAddChatIdAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: TeamAddChatIdAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: TeamAddChatIdAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const TEAM_DELETE_PLAYER_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type TeamDeletePlayerAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof TEAM_DELETE_PLAYER_ERROR_TYPES
  >[number];

export class TeamDeletePlayerAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      TEAM_DELETE_PLAYER_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new TeamDeletePlayerAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new TeamDeletePlayerAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: TeamDeletePlayerAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: TeamDeletePlayerAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const TEAM_GRAB_OBJECTIVE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type TeamGrabObjectiveAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof TEAM_GRAB_OBJECTIVE_ERROR_TYPES
  >[number];

export class TeamGrabObjectiveAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      TEAM_GRAB_OBJECTIVE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new TeamGrabObjectiveAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new TeamGrabObjectiveAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: TeamGrabObjectiveAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: TeamGrabObjectiveAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const TEAM_CURRENT_OBJECTIVE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type TeamCurrentObjectiveAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof TEAM_CURRENT_OBJECTIVE_ERROR_TYPES
  >[number];

export class TeamCurrentObjectiveAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      TEAM_CURRENT_OBJECTIVE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new TeamCurrentObjectiveAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new TeamCurrentObjectiveAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: TeamCurrentObjectiveAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: TeamCurrentObjectiveAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const TEAM_REMOVE_OBJECTIVE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type TeamRemoveObjectiveAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof TEAM_REMOVE_OBJECTIVE_ERROR_TYPES
  >[number];

export class TeamRemoveObjectiveAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      TEAM_REMOVE_OBJECTIVE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new TeamRemoveObjectiveAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new TeamRemoveObjectiveAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: TeamRemoveObjectiveAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: TeamRemoveObjectiveAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const TEAM_SEND_PING_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type TeamSendPingAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof TEAM_SEND_PING_ERROR_TYPES
  >[number];

export class TeamSendPingAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      TEAM_SEND_PING_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new TeamSendPingAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new TeamSendPingAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: TeamSendPingAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: TeamSendPingAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const TEAM_SET_EXTRA_PINGS_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type TeamSetExtraPingsAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof TEAM_SET_EXTRA_PINGS_ERROR_TYPES
  >[number];

export class TeamSetExtraPingsAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      TEAM_SET_EXTRA_PINGS_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new TeamSetExtraPingsAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new TeamSetExtraPingsAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: TeamSetExtraPingsAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: TeamSetExtraPingsAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}


export interface UseTeamApi {
  mutators: TeamMutators;
  create: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamCreateRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        TeamCreateResponse,
        TeamCreateAborted
      >>;

    pending: PendingTeamCreateRequestMutation[];
  };
  join: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamJoinRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        TeamJoinResponse,
        TeamJoinAborted
      >>;

    pending: PendingTeamJoinRequestMutation[];
  };
  usePlayers: (
    partialRequest?: __bufbuildProtobufPartialMessage<PlayersRequest>
  ) => {
    response: PlayersResponse | undefined;
    isLoading: boolean;
    aborted: undefined | TeamPlayersAborted;
  };
  players: (
    partialRequest?: __bufbuildProtobufPartialMessage<PlayersRequest>,
    options?: { signal?: AbortSignal }
  ) => Promise<
    reboot_web.ResponseOrAborted<
    PlayersResponse,
    TeamPlayersAborted
    >
  >;
  useInfo: (
    partialRequest?: __bufbuildProtobufPartialMessage<TeamInfoRequest>
  ) => {
    response: TeamInfoResponse | undefined;
    isLoading: boolean;
    aborted: undefined | TeamInfoAborted;
  };
  info: (
    partialRequest?: __bufbuildProtobufPartialMessage<TeamInfoRequest>,
    options?: { signal?: AbortSignal }
  ) => Promise<
    reboot_web.ResponseOrAborted<
    TeamInfoResponse,
    TeamInfoAborted
    >
  >;
  addChatId: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamAddChatIdRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamAddChatIdAborted
      >>;

    pending: PendingTeamAddChatIdRequestMutation[];
  };
  deletePlayer: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamDeletePlayerRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamDeletePlayerAborted
      >>;

    pending: PendingTeamDeletePlayerRequestMutation[];
  };
  grabObjective: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamGrabObjectiveRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamGrabObjectiveAborted
      >>;

    pending: PendingTeamGrabObjectiveRequestMutation[];
  };
  useCurrentObjective: (
    partialRequest?: __bufbuildProtobufPartialMessage<Empty>
  ) => {
    response: TeamCurrentObjectiveResponse | undefined;
    isLoading: boolean;
    aborted: undefined | TeamCurrentObjectiveAborted;
  };
  currentObjective: (
    partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
    options?: { signal?: AbortSignal }
  ) => Promise<
    reboot_web.ResponseOrAborted<
    TeamCurrentObjectiveResponse,
    TeamCurrentObjectiveAborted
    >
  >;
  removeObjective: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamRemoveObjectiveRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamRemoveObjectiveAborted
      >>;

    pending: PendingTeamRemoveObjectiveRequestMutation[];
  };
  sendPing: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamSendPingAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  setExtraPings: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<TeamSetExtraPingsRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamSetExtraPingsAborted
      >>;

    pending: PendingTeamSetExtraPingsRequestMutation[];
  };
}
export interface PlayerMutators {
  create: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<PlayerCreateRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        PlayerCreateResponse,
        PlayerCreateAborted
      >>;

    pending: PendingPlayerCreateRequestMutation[];
  };
  addCoordinates: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<PlayerAddCoordinatesRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        PlayerAddCoordinatesResponse,
        PlayerAddCoordinatesAborted
      >>;

    pending: PendingPlayerAddCoordinatesRequestMutation[];
  };
  clearState: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        PlayerClearStateAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  sendPing: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        PlayerSendPingAborted
      >>;

    pending: PendingEmptyMutation[];
  };
}

const PLAYER_CREATE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PlayerCreateAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PLAYER_CREATE_ERROR_TYPES
  >[number];

export class PlayerCreateAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PLAYER_CREATE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PlayerCreateAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PlayerCreateAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PlayerCreateAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: PlayerCreateAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const PLAYER_VISIBLE_INFO_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PlayerVisibleInfoAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PLAYER_VISIBLE_INFO_ERROR_TYPES
  >[number];

export class PlayerVisibleInfoAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PLAYER_VISIBLE_INFO_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PlayerVisibleInfoAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PlayerVisibleInfoAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PlayerVisibleInfoAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: PlayerVisibleInfoAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const PLAYER_ADD_COORDINATES_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PlayerAddCoordinatesAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PLAYER_ADD_COORDINATES_ERROR_TYPES
  >[number];

export class PlayerAddCoordinatesAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PLAYER_ADD_COORDINATES_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PlayerAddCoordinatesAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PlayerAddCoordinatesAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PlayerAddCoordinatesAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: PlayerAddCoordinatesAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const PLAYER_CURRENT_COORDINATES_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PlayerCurrentCoordinatesAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PLAYER_CURRENT_COORDINATES_ERROR_TYPES
  >[number];

export class PlayerCurrentCoordinatesAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PLAYER_CURRENT_COORDINATES_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PlayerCurrentCoordinatesAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PlayerCurrentCoordinatesAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PlayerCurrentCoordinatesAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: PlayerCurrentCoordinatesAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const PLAYER_NAME_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PlayerNameAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PLAYER_NAME_ERROR_TYPES
  >[number];

export class PlayerNameAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PLAYER_NAME_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PlayerNameAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PlayerNameAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PlayerNameAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: PlayerNameAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const PLAYER_TEAM_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PlayerTeamAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PLAYER_TEAM_ERROR_TYPES
  >[number];

export class PlayerTeamAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PLAYER_TEAM_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PlayerTeamAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PlayerTeamAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PlayerTeamAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: PlayerTeamAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const PLAYER_CLEAR_STATE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PlayerClearStateAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PLAYER_CLEAR_STATE_ERROR_TYPES
  >[number];

export class PlayerClearStateAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PLAYER_CLEAR_STATE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PlayerClearStateAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PlayerClearStateAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PlayerClearStateAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: PlayerClearStateAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const PLAYER_SEND_PING_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PlayerSendPingAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PLAYER_SEND_PING_ERROR_TYPES
  >[number];

export class PlayerSendPingAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PLAYER_SEND_PING_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PlayerSendPingAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PlayerSendPingAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PlayerSendPingAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: PlayerSendPingAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}


export interface UsePlayerApi {
  mutators: PlayerMutators;
  create: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<PlayerCreateRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        PlayerCreateResponse,
        PlayerCreateAborted
      >>;

    pending: PendingPlayerCreateRequestMutation[];
  };
  useVisibleInfo: (
    partialRequest?: __bufbuildProtobufPartialMessage<PlayerVisibleInfoRequest>
  ) => {
    response: PlayerVisibleInfoResponse | undefined;
    isLoading: boolean;
    aborted: undefined | PlayerVisibleInfoAborted;
  };
  visibleInfo: (
    partialRequest?: __bufbuildProtobufPartialMessage<PlayerVisibleInfoRequest>,
    options?: { signal?: AbortSignal }
  ) => Promise<
    reboot_web.ResponseOrAborted<
    PlayerVisibleInfoResponse,
    PlayerVisibleInfoAborted
    >
  >;
  addCoordinates: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<PlayerAddCoordinatesRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        PlayerAddCoordinatesResponse,
        PlayerAddCoordinatesAborted
      >>;

    pending: PendingPlayerAddCoordinatesRequestMutation[];
  };
  useCurrentCoordinates: (
    partialRequest?: __bufbuildProtobufPartialMessage<PlayerCurrentCoordinatesRequest>
  ) => {
    response: PlayerCurrentCoordinatesResponse | undefined;
    isLoading: boolean;
    aborted: undefined | PlayerCurrentCoordinatesAborted;
  };
  currentCoordinates: (
    partialRequest?: __bufbuildProtobufPartialMessage<PlayerCurrentCoordinatesRequest>,
    options?: { signal?: AbortSignal }
  ) => Promise<
    reboot_web.ResponseOrAborted<
    PlayerCurrentCoordinatesResponse,
    PlayerCurrentCoordinatesAborted
    >
  >;
  useName: (
    partialRequest?: __bufbuildProtobufPartialMessage<PlayerNameRequest>
  ) => {
    response: PlayerNameResponse | undefined;
    isLoading: boolean;
    aborted: undefined | PlayerNameAborted;
  };
  name: (
    partialRequest?: __bufbuildProtobufPartialMessage<PlayerNameRequest>,
    options?: { signal?: AbortSignal }
  ) => Promise<
    reboot_web.ResponseOrAborted<
    PlayerNameResponse,
    PlayerNameAborted
    >
  >;
  useTeam: (
    partialRequest?: __bufbuildProtobufPartialMessage<PlayerTeamRequest>
  ) => {
    response: PlayerTeamResponse | undefined;
    isLoading: boolean;
    aborted: undefined | PlayerTeamAborted;
  };
  team: (
    partialRequest?: __bufbuildProtobufPartialMessage<PlayerTeamRequest>,
    options?: { signal?: AbortSignal }
  ) => Promise<
    reboot_web.ResponseOrAborted<
    PlayerTeamResponse,
    PlayerTeamAborted
    >
  >;
  clearState: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        PlayerClearStateAborted
      >>;

    pending: PendingEmptyMutation[];
  };
  sendPing: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        PlayerSendPingAborted
      >>;

    pending: PendingEmptyMutation[];
  };
}
export interface LocationMutators {
  set: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<LocationSetRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        LocationSetAborted
      >>;

    pending: PendingLocationSetRequestMutation[];
  };
  releaseToTeam: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<LocationReleaseToTeamRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        LocationReleaseToTeamResponse,
        LocationReleaseToTeamAborted
      >>;

    pending: PendingLocationReleaseToTeamRequestMutation[];
  };
}

const LOCATION_SET_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type LocationSetAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof LOCATION_SET_ERROR_TYPES
  >[number];

export class LocationSetAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      LOCATION_SET_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new LocationSetAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new LocationSetAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: LocationSetAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: LocationSetAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const LOCATION_RELEASE_TO_TEAM_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type LocationReleaseToTeamAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof LOCATION_RELEASE_TO_TEAM_ERROR_TYPES
  >[number];

export class LocationReleaseToTeamAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      LOCATION_RELEASE_TO_TEAM_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new LocationReleaseToTeamAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new LocationReleaseToTeamAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: LocationReleaseToTeamAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: LocationReleaseToTeamAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}

const LOCATION_GET_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type LocationGetAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof LOCATION_GET_ERROR_TYPES
  >[number];

export class LocationGetAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      LOCATION_GET_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new LocationGetAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new LocationGetAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: LocationGetAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  readonly error: LocationGetAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}


export interface UseLocationApi {
  mutators: LocationMutators;
  set: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<LocationSetRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        LocationSetAborted
      >>;

    pending: PendingLocationSetRequestMutation[];
  };
  releaseToTeam: {
    // Mutators are functions and can be called directly.
    (partialRequest?: __bufbuildProtobufPartialMessage<LocationReleaseToTeamRequest>,
     options?: { metadata?: any }
    ): Promise<
      reboot_web.ResponseOrAborted<
        LocationReleaseToTeamResponse,
        LocationReleaseToTeamAborted
      >>;

    pending: PendingLocationReleaseToTeamRequestMutation[];
  };
  useGet: (
    partialRequest?: __bufbuildProtobufPartialMessage<Empty>
  ) => {
    response: LocationProto | undefined;
    isLoading: boolean;
    aborted: undefined | LocationGetAborted;
  };
  get: (
    partialRequest?: __bufbuildProtobufPartialMessage<Empty>,
    options?: { signal?: AbortSignal }
  ) => Promise<
    reboot_web.ResponseOrAborted<
    LocationProto,
    LocationGetAborted
    >
  >;
}

export interface SettingsParams {
  id: string;
  storeMutationsLocallyInNamespace?: string;
}

class GameInstance {

  constructor(id: string, stateRef: string, url: string) {
    this.id = id;
    this.stateRef = stateRef;
    this.url = url;
    this.refs = 1;

     reboot_web.websockets.connect(this.url, this.stateRef);
    this.initializeWebSocket();
  }

  private ref() {
    this.refs += 1;
    return this.refs;
  }

  private unref() {
    this.refs -= 1;

    if (this.refs === 0 && this.websocket !== undefined) {
      this.websocket.close();
       reboot_web.websockets.disconnect(this.url, this.stateRef);
    }

    return this.refs;
  }

  readonly id: string;
  readonly stateRef: string;
  private url: string;
  private refs: number;
  private observers: reboot_react.Observers = {};
  private loadingReaders = 0;
  private runningMutates: reboot_react.Mutate[] = [];
  private queuedMutates: reboot_react.Mutate[] = [];
  private flushMutates?: reboot_api.Event = undefined;
  private websocket?: WebSocket = undefined;
  private backoff: reboot_api.Backoff = new reboot_api.Backoff();

  private hasRunningMutations() {
    return this.runningMutates.length > 0;
  }

  private async flushMutations() {
    if (this.flushMutates === undefined) {
      this.flushMutates = new reboot_api.Event();
    }
    await this.flushMutates.wait();
  }

  private readersLoadedOrFailed() {
    this.flushMutates = undefined;

    if (this.queuedMutates.length > 0) {
      this.runningMutates = this.queuedMutates;
      this.queuedMutates = [];

      if (this.websocket?.readyState === WebSocket.OPEN) {
        for (const { request, update } of this.runningMutates) {
          update({ isLoading: true });
          try {
            this.websocket.send(request.toBinary());
          } catch {
            // We'll retry since we've stored in `*Mutates`.
          }
        }
      }
    }
  }

  private initializeWebSocket() {
    if (this.websocket === undefined && this.refs > 0) {
      const url = new URL(`${this.url}/__/reboot/rpc/${this.stateRef}`);
      url.protocol = url.protocol === "https:" ? "wss:" : "ws:";

      this.websocket = reboot_web.websockets.create(url);

      this.websocket.binaryType = "arraybuffer";

      this.websocket.onopen = () => {
        if (this.websocket?.readyState === WebSocket.OPEN) {
          for (const { request, update } of this.runningMutates) {
            update({ isLoading: true });
            try {
              this.websocket.send(request.toBinary());
            } catch {
              // We'll retry since we've stored in `*Mutates`.
            }
          }
        }
      };

      this.websocket.onerror = async () => {
        if (this.websocket !== undefined) {
          this.websocket = undefined;

          for (const { update } of this.runningMutates) {
            update({ isLoading: false, error: "WebSocket disconnected" });
          }

          if (this.refs > 0) {
            if (this.runningMutates.length > 0) {
              console.warn(
                `WebSocket disconnected, ${this.runningMutates.length} outstanding mutations will be retried when we reconnect`
              );
            }

            await this.backoff.wait();

            this.initializeWebSocket();
          }
        }
      };

      this.websocket.onclose = async () => {
        if (this.websocket !== undefined) {
          this.websocket = undefined;

          for (const { update } of this.runningMutates) {
            update({ isLoading: false, error: "WebSocket disconnected" });
          }

          if (this.refs > 0) {
            await this.backoff.wait();

            this.initializeWebSocket();
          }
        }
      };

      this.websocket.onmessage = async (event) => {
        const { resolve } = this.runningMutates[0];
        this.runningMutates.shift();

        const response = reboot_api.react_pb.MutateResponse.fromBinary(
          new Uint8Array(event.data)
        );

        resolve(response);

        if (
          this.flushMutates !== undefined &&
          this.runningMutates.length === 0
        ) {
          this.flushMutates.set();
        }
      };
    }
  }

  private async mutate(
    partialRequest: __bufbuildProtobufPartialMessage<reboot_api.react_pb.MutateRequest>,
    update: (props: { isLoading: boolean; error?: any }) => void
  ): Promise<reboot_api.react_pb.MutateResponse> {
    const request = partialRequest instanceof reboot_api.react_pb.MutateRequest
      ? partialRequest
      : new reboot_api.react_pb.MutateRequest(partialRequest);

    return new Promise((resolve, _) => {
      if (this.loadingReaders === 0) {
        this.runningMutates = this.runningMutates.concat({ request, resolve, update });
        if (this.websocket?.readyState === WebSocket.OPEN) {
          update({ isLoading: true });
          try {
            this.websocket.send(request.toBinary());
          } catch {
            // We'll retry since we've stored in `*Mutates`.
          }
        }
      } else {
        this.queuedMutates = this.queuedMutates.concat({ request, resolve, update });
      }
    });
  }

  private async read<
    RequestType extends __bufbuildProtobufMessage<RequestType>,
    ResponseType extends __bufbuildProtobufMessage<ResponseType>,
    >(
    method: string,
    request: RequestType,
    bearerToken: string | undefined,
    responseType: __bufbuildProtobufMessageType<ResponseType>,
    reader: reboot_react.Reader<ResponseType>
  ) {
    const queryRequest = new reboot_api.react_pb.QueryRequest({
      method,
      request: request.toBinary(),
      ...(bearerToken !== undefined && { bearerToken } || {}),
    });

    // Expected idempotency key we should observe due to a mutation.
    interface Expected {
      // Idempotency key of mutation.
      idempotencyKey: string;

      // Callback when we've observed this idempotency key.
      observed: (callback: () => void) => Promise<void>;

      // Callback when we no longer care about observing.
      aborted: () => void;
    }

    let expecteds: Expected[] = [];

    // When we disconnect we may not be able to observe
    // responses due to mutations yet there may still be
    // some outstanding responses that are expected which
    // we treat as "orphans" in the sense that we won't
    // observe their idempotency keys but once we reconnect
    // we will still have observed their effects and can
    // call `observed()` on them.
    let orphans: Expected[] = [];

    const id = `${uuidv4()}`;

    this.observers[id] = {
      observe: (
        idempotencyKey: string,
        observed: (callback: () => void) => Promise<void>,
        aborted: () => void
      ) => {
        expecteds = expecteds.concat({ idempotencyKey, observed, aborted })
      },
      unobserve: (idempotencyKey: string) => {
        expecteds = expecteds.filter(
          expected => expected.idempotencyKey !== idempotencyKey
        );
      }
    };

    try {
      await reboot_api.retryForever(async () => {
        let loaded = false;
        this.loadingReaders += 1;

        // Any mutations started after we've incremented
        // `this.loadingReaders` will be queued until after
        // all the readers have loaded and thus (1) we know all
        // current `expected` are actually `orphans` that
        // we will haved "observed" once we are (re)connected
        // because we flush mutations before starting to read
        // and (2) all queued mutations can stay in `expected`
        // because we will in fact be able to observe them
        // since they won't get sent over the websocket
        // until after we are (re)connected.
        //
        // NOTE: we need to concatenate with `orphans`
        // because we may try to (re)connect multiple times
        // and between each try more mutations may have been
        // made (or queued ones will be moved to running).
        orphans = [...orphans, ...expecteds];
        expecteds = [];

        try {
          // Wait for potentially completed mutations to flush
          // before starting to read so that we read the latest
          // state including those mutations.
          if (this.hasRunningMutations()) {
            await this.flushMutations();
          }

          unstable_batchedUpdates(() => {
            for (const setIsLoading of Object.values(reader.setIsLoadings)) {
              setIsLoading(true);
            }
          });

          const queryResponses = reboot_web.reactiveReader({
            endpoint: `${this.url}/__/reboot/rpc/${this.stateRef}`,
            request: queryRequest,
            signal: reader.abortController.signal,
          });

          for await (const queryResponse of queryResponses) {
            if (!loaded) {
              if ((this.loadingReaders -= 1) === 0) {
                this.readersLoadedOrFailed();
              }
              loaded = true;
            }

            unstable_batchedUpdates(() => {
              for (const setIsLoading of Object.values(reader.setIsLoadings)) {
                setIsLoading(false);
              }
            });

            const response = queryResponse.responseOrStatus.case === "response"
              ? responseType.fromBinary(queryResponse.responseOrStatus.value)
              : undefined;

            // If we were disconnected it must be that we've
            // observed all `orphans` because we waited
            // for any mutations to flush before we re-started to
            // read.
            if (orphans.length > 0) {
              // We mark all mutations as observed except the
              // last one which we also invoke all `setResponse`s.
              // In this way we effectively create a barrier
              // for all readers that will synchronize on the last
              // mutation, but note that this still may lead
              // to some partial state/response updates because
              // one reader may have actually received a response
              // while another reader got disconnected. While this
              // is likely very rare, it is possible. Mitigating
              // this issue is non-trivial and for now we have
              // no plans to address it.
              for (let i = 0; i < orphans.length - 1; i++) {
                orphans[i].observed(() => {});
              }
              await orphans[orphans.length - 1].observed(() => {
                if (response !== undefined) {
                  reader.response = response;
                  for (const setResponse of Object.values(reader.setResponses)) {
                    setResponse(response);
                  }
                }
              });

              orphans = [];
            } else if (
              expecteds.length > 0 &&
              queryResponse.idempotencyKeys.includes(
                expecteds[0].idempotencyKey
              )
            ) {
              await expecteds[0].observed(() => {
                if (response !== undefined) {
                  reader.response = response;
                  for (const setResponse of Object.values(reader.setResponses)) {
                    setResponse(response);
                  }
                }
                expecteds.shift();
              });
            } else if (response !== undefined) {
              unstable_batchedUpdates(() => {
                reader.response = response;
                for (const setResponse of Object.values(reader.setResponses)) {
                  setResponse(response);
                }
              });
            }
          }

          throw new Error('Not expecting stream to ever be done');
        } catch (e: unknown) {
          if (!loaded) {
            if ((this.loadingReaders -= 1) === 0) {
              this.readersLoadedOrFailed();
            }
          }

          loaded = false;

          if (reader.abortController.signal.aborted) {
            for (const { aborted } of [...orphans, ...expecteds]) {
              aborted();
            }
            return;
          }

          unstable_batchedUpdates(() => {
            for (const setIsLoading of Object.values(reader.setIsLoadings)) {
              setIsLoading(false);
            }
            for (const setStatus of Object.values(reader.setStatuses)) {
              if (e instanceof reboot_api.Status) {
                setStatus(e);
              } else {
                setStatus(
                  new reboot_api.Status({
                    code: reboot_api.StatusCode.UNKNOWN,
                    message: e instanceof Error
                      ? e.message
                      : JSON.stringify(e),
                  })
                );
              }
            }
          });

          throw e; // This just retries!
        }
      });
    } finally {
      delete this.observers[id];
    }
  }


  private useCreateMutations: (
    PendingGameCreateRequestMutation)[] = [];

  private useCreateSetPendings: {
    [id: string]: (mutations: PendingGameCreateRequestMutation[]) => void
  } = {};

  async create(
    mutation: PendingGameCreateRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      GameCreateResponse,
      GameCreateAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useCreateMutations = this.useCreateMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useCreateSetPendings)) {
        setPending(this.useCreateMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        GameCreateResponse,
        GameCreateAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "Create",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useCreateMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useCreateSetPendings)) {
                  setPending(this.useCreateMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useCreateMutations =
            this.useCreateMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useCreateSetPendings)) {
              setPending(this.useCreateMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: GameCreateResponse.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameCreateAborted.fromStatus(status);

            console.warn(
              `'Game.Create' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useCreate(
    id: string,
    setPending: (mutations: PendingGameCreateRequestMutation[]) => void
  ) {
    this.useCreateSetPendings[id] = setPending;
  }

  unuseCreate(id: string) {
    delete this.useCreateSetPendings[id];
  }


  private useOverviewReaders: {
    [id: string]: reboot_react.Reader<GameOverviewResponse>
  } = {};

  useOverview(
    id: string,
    request: GameOverviewRequest,
    bearerToken: string | undefined,
    setResponse: (response: GameOverviewResponse) => void,
    setIsLoading: (isLoading: boolean) => void,
    setStatus: (status: reboot_api.Status) => void
  ) {
    let read = false;

    // NOTE: need to concatenate `request.toJsonString()` with `bearerToken`
    // because it uniquely identifies the request, i.e., a second call
    // that has the same `request` but a different bearerToken should be a
    // different call.
    const key = request.toJsonString() + bearerToken;

    if (!(key in this.useOverviewReaders)) {
      this.useOverviewReaders[key] = {
        abortController: new AbortController(),
        setResponses: {},
        setIsLoadings: {},
        setStatuses: {},
      };

      read = true;
    }

    let reader = this.useOverviewReaders[key];

    reader.setResponses[id] = setResponse;
    reader.setIsLoadings[id] = setIsLoading;
    reader.setStatuses[id] = setStatus;

    if (reader.response !== undefined) {
      setResponse(reader.response);
    }

    if (read) {
      this.read(
        "Overview",
        request,
        bearerToken,
        GameOverviewResponse,
        reader
      );
    }
  }

  unuseOverview(
    id: string,
    request: GameOverviewRequest,
    bearerToken: string | undefined
  ) {
    // See comment above in `useOverview` for why
    // we concatenate `request.toJsonString()` with `bearerToken`.
    const key = request.toJsonString() + bearerToken;

    const reader = this.useOverviewReaders[key];

    delete reader.setResponses[id];
    delete reader.setIsLoadings[id];
    delete reader.setStatuses[id];

    if (Object.values(reader.setResponses).length === 0) {
      delete this.useOverviewReaders[key];
      reader.abortController.abort();
    }
  }


  private useStartMutations: (
    PendingEmptyMutation)[] = [];

  private useStartSetPendings: {
    [id: string]: (mutations: PendingEmptyMutation[]) => void
  } = {};

  async start(
    mutation: PendingEmptyMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameStartAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useStartMutations = this.useStartMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useStartSetPendings)) {
        setPending(this.useStartMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameStartAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "Start",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useStartMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useStartSetPendings)) {
                  setPending(this.useStartMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useStartMutations =
            this.useStartMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useStartSetPendings)) {
              setPending(this.useStartMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameStartAborted.fromStatus(status);

            console.warn(
              `'Game.Start' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useStart(
    id: string,
    setPending: (mutations: PendingEmptyMutation[]) => void
  ) {
    this.useStartSetPendings[id] = setPending;
  }

  unuseStart(id: string) {
    delete this.useStartSetPendings[id];
  }


  private usePauseMutations: (
    PendingEmptyMutation)[] = [];

  private usePauseSetPendings: {
    [id: string]: (mutations: PendingEmptyMutation[]) => void
  } = {};

  async pause(
    mutation: PendingEmptyMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GamePauseAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.usePauseMutations = this.usePauseMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.usePauseSetPendings)) {
        setPending(this.usePauseMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GamePauseAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "Pause",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.usePauseMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.usePauseSetPendings)) {
                  setPending(this.usePauseMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.usePauseMutations =
            this.usePauseMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.usePauseSetPendings)) {
              setPending(this.usePauseMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GamePauseAborted.fromStatus(status);

            console.warn(
              `'Game.Pause' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  usePause(
    id: string,
    setPending: (mutations: PendingEmptyMutation[]) => void
  ) {
    this.usePauseSetPendings[id] = setPending;
  }

  unusePause(id: string) {
    delete this.usePauseSetPendings[id];
  }


  private useUnpauseMutations: (
    PendingEmptyMutation)[] = [];

  private useUnpauseSetPendings: {
    [id: string]: (mutations: PendingEmptyMutation[]) => void
  } = {};

  async unpause(
    mutation: PendingEmptyMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameUnpauseAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useUnpauseMutations = this.useUnpauseMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useUnpauseSetPendings)) {
        setPending(this.useUnpauseMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameUnpauseAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "Unpause",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useUnpauseMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useUnpauseSetPendings)) {
                  setPending(this.useUnpauseMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useUnpauseMutations =
            this.useUnpauseMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useUnpauseSetPendings)) {
              setPending(this.useUnpauseMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameUnpauseAborted.fromStatus(status);

            console.warn(
              `'Game.Unpause' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useUnpause(
    id: string,
    setPending: (mutations: PendingEmptyMutation[]) => void
  ) {
    this.useUnpauseSetPendings[id] = setPending;
  }

  unuseUnpause(id: string) {
    delete this.useUnpauseSetPendings[id];
  }


  private useCountdownMutations: (
    PendingGameCountdownRequestMutation)[] = [];

  private useCountdownSetPendings: {
    [id: string]: (mutations: PendingGameCountdownRequestMutation[]) => void
  } = {};

  async countdown(
    mutation: PendingGameCountdownRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameCountdownAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useCountdownMutations = this.useCountdownMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useCountdownSetPendings)) {
        setPending(this.useCountdownMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameCountdownAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "Countdown",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useCountdownMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useCountdownSetPendings)) {
                  setPending(this.useCountdownMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useCountdownMutations =
            this.useCountdownMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useCountdownSetPendings)) {
              setPending(this.useCountdownMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameCountdownAborted.fromStatus(status);

            console.warn(
              `'Game.Countdown' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useCountdown(
    id: string,
    setPending: (mutations: PendingGameCountdownRequestMutation[]) => void
  ) {
    this.useCountdownSetPendings[id] = setPending;
  }

  unuseCountdown(id: string) {
    delete this.useCountdownSetPendings[id];
  }


  private useAddLocationMutations: (
    PendingLocationInfoMutation)[] = [];

  private useAddLocationSetPendings: {
    [id: string]: (mutations: PendingLocationInfoMutation[]) => void
  } = {};

  async addLocation(
    mutation: PendingLocationInfoMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameAddLocationAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useAddLocationMutations = this.useAddLocationMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useAddLocationSetPendings)) {
        setPending(this.useAddLocationMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameAddLocationAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "AddLocation",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useAddLocationMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useAddLocationSetPendings)) {
                  setPending(this.useAddLocationMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useAddLocationMutations =
            this.useAddLocationMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useAddLocationSetPendings)) {
              setPending(this.useAddLocationMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameAddLocationAborted.fromStatus(status);

            console.warn(
              `'Game.AddLocation' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useAddLocation(
    id: string,
    setPending: (mutations: PendingLocationInfoMutation[]) => void
  ) {
    this.useAddLocationSetPendings[id] = setPending;
  }

  unuseAddLocation(id: string) {
    delete this.useAddLocationSetPendings[id];
  }


  private useReleaseLocationsMutations: (
    PendingEmptyMutation)[] = [];

  private useReleaseLocationsSetPendings: {
    [id: string]: (mutations: PendingEmptyMutation[]) => void
  } = {};

  async releaseLocations(
    mutation: PendingEmptyMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameReleaseLocationsAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useReleaseLocationsMutations = this.useReleaseLocationsMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useReleaseLocationsSetPendings)) {
        setPending(this.useReleaseLocationsMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameReleaseLocationsAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "ReleaseLocations",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useReleaseLocationsMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useReleaseLocationsSetPendings)) {
                  setPending(this.useReleaseLocationsMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useReleaseLocationsMutations =
            this.useReleaseLocationsMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useReleaseLocationsSetPendings)) {
              setPending(this.useReleaseLocationsMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameReleaseLocationsAborted.fromStatus(status);

            console.warn(
              `'Game.ReleaseLocations' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useReleaseLocations(
    id: string,
    setPending: (mutations: PendingEmptyMutation[]) => void
  ) {
    this.useReleaseLocationsSetPendings[id] = setPending;
  }

  unuseReleaseLocations(id: string) {
    delete this.useReleaseLocationsSetPendings[id];
  }


  private useAddChatIdsMutations: (
    PendingGameAddChatIdsRequestMutation)[] = [];

  private useAddChatIdsSetPendings: {
    [id: string]: (mutations: PendingGameAddChatIdsRequestMutation[]) => void
  } = {};

  async addChatIds(
    mutation: PendingGameAddChatIdsRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameAddChatIdsAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useAddChatIdsMutations = this.useAddChatIdsMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useAddChatIdsSetPendings)) {
        setPending(this.useAddChatIdsMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameAddChatIdsAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "AddChatIds",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useAddChatIdsMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useAddChatIdsSetPendings)) {
                  setPending(this.useAddChatIdsMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useAddChatIdsMutations =
            this.useAddChatIdsMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useAddChatIdsSetPendings)) {
              setPending(this.useAddChatIdsMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameAddChatIdsAborted.fromStatus(status);

            console.warn(
              `'Game.AddChatIds' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useAddChatIds(
    id: string,
    setPending: (mutations: PendingGameAddChatIdsRequestMutation[]) => void
  ) {
    this.useAddChatIdsSetPendings[id] = setPending;
  }

  unuseAddChatIds(id: string) {
    delete this.useAddChatIdsSetPendings[id];
  }


  private useTeamChatIdsReaders: {
    [id: string]: reboot_react.Reader<GameTeamChatIdsResponse>
  } = {};

  useTeamChatIds(
    id: string,
    request: Empty,
    bearerToken: string | undefined,
    setResponse: (response: GameTeamChatIdsResponse) => void,
    setIsLoading: (isLoading: boolean) => void,
    setStatus: (status: reboot_api.Status) => void
  ) {
    let read = false;

    // NOTE: need to concatenate `request.toJsonString()` with `bearerToken`
    // because it uniquely identifies the request, i.e., a second call
    // that has the same `request` but a different bearerToken should be a
    // different call.
    const key = request.toJsonString() + bearerToken;

    if (!(key in this.useTeamChatIdsReaders)) {
      this.useTeamChatIdsReaders[key] = {
        abortController: new AbortController(),
        setResponses: {},
        setIsLoadings: {},
        setStatuses: {},
      };

      read = true;
    }

    let reader = this.useTeamChatIdsReaders[key];

    reader.setResponses[id] = setResponse;
    reader.setIsLoadings[id] = setIsLoading;
    reader.setStatuses[id] = setStatus;

    if (reader.response !== undefined) {
      setResponse(reader.response);
    }

    if (read) {
      this.read(
        "TeamChatIds",
        request,
        bearerToken,
        GameTeamChatIdsResponse,
        reader
      );
    }
  }

  unuseTeamChatIds(
    id: string,
    request: Empty,
    bearerToken: string | undefined
  ) {
    // See comment above in `useTeamChatIds` for why
    // we concatenate `request.toJsonString()` with `bearerToken`.
    const key = request.toJsonString() + bearerToken;

    const reader = this.useTeamChatIdsReaders[key];

    delete reader.setResponses[id];
    delete reader.setIsLoadings[id];
    delete reader.setStatuses[id];

    if (Object.values(reader.setResponses).length === 0) {
      delete this.useTeamChatIdsReaders[key];
      reader.abortController.abort();
    }
  }


  private useBroadcastMutations: (
    PendingGameBroadcastRequestMutation)[] = [];

  private useBroadcastSetPendings: {
    [id: string]: (mutations: PendingGameBroadcastRequestMutation[]) => void
  } = {};

  async broadcast(
    mutation: PendingGameBroadcastRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameBroadcastAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useBroadcastMutations = this.useBroadcastMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useBroadcastSetPendings)) {
        setPending(this.useBroadcastMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameBroadcastAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "Broadcast",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useBroadcastMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useBroadcastSetPendings)) {
                  setPending(this.useBroadcastMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useBroadcastMutations =
            this.useBroadcastMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useBroadcastSetPendings)) {
              setPending(this.useBroadcastMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameBroadcastAborted.fromStatus(status);

            console.warn(
              `'Game.Broadcast' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useBroadcast(
    id: string,
    setPending: (mutations: PendingGameBroadcastRequestMutation[]) => void
  ) {
    this.useBroadcastSetPendings[id] = setPending;
  }

  unuseBroadcast(id: string) {
    delete this.useBroadcastSetPendings[id];
  }


  private useDeletePlayerMutations: (
    PendingGameDeletePlayerRequestMutation)[] = [];

  private useDeletePlayerSetPendings: {
    [id: string]: (mutations: PendingGameDeletePlayerRequestMutation[]) => void
  } = {};

  async deletePlayer(
    mutation: PendingGameDeletePlayerRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameDeletePlayerAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useDeletePlayerMutations = this.useDeletePlayerMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useDeletePlayerSetPendings)) {
        setPending(this.useDeletePlayerMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameDeletePlayerAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "DeletePlayer",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useDeletePlayerMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useDeletePlayerSetPendings)) {
                  setPending(this.useDeletePlayerMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useDeletePlayerMutations =
            this.useDeletePlayerMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useDeletePlayerSetPendings)) {
              setPending(this.useDeletePlayerMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameDeletePlayerAborted.fromStatus(status);

            console.warn(
              `'Game.DeletePlayer' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useDeletePlayer(
    id: string,
    setPending: (mutations: PendingGameDeletePlayerRequestMutation[]) => void
  ) {
    this.useDeletePlayerSetPendings[id] = setPending;
  }

  unuseDeletePlayer(id: string) {
    delete this.useDeletePlayerSetPendings[id];
  }


  private useRemoveObjectiveMutations: (
    PendingGameRemoveObjectiveRequestMutation)[] = [];

  private useRemoveObjectiveSetPendings: {
    [id: string]: (mutations: PendingGameRemoveObjectiveRequestMutation[]) => void
  } = {};

  async removeObjective(
    mutation: PendingGameRemoveObjectiveRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameRemoveObjectiveAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useRemoveObjectiveMutations = this.useRemoveObjectiveMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useRemoveObjectiveSetPendings)) {
        setPending(this.useRemoveObjectiveMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameRemoveObjectiveAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "RemoveObjective",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useRemoveObjectiveMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useRemoveObjectiveSetPendings)) {
                  setPending(this.useRemoveObjectiveMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useRemoveObjectiveMutations =
            this.useRemoveObjectiveMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useRemoveObjectiveSetPendings)) {
              setPending(this.useRemoveObjectiveMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameRemoveObjectiveAborted.fromStatus(status);

            console.warn(
              `'Game.RemoveObjective' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useRemoveObjective(
    id: string,
    setPending: (mutations: PendingGameRemoveObjectiveRequestMutation[]) => void
  ) {
    this.useRemoveObjectiveSetPendings[id] = setPending;
  }

  unuseRemoveObjective(id: string) {
    delete this.useRemoveObjectiveSetPendings[id];
  }


  private useSendPingMutations: (
    PendingEmptyMutation)[] = [];

  private useSendPingSetPendings: {
    [id: string]: (mutations: PendingEmptyMutation[]) => void
  } = {};

  async sendPing(
    mutation: PendingEmptyMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameSendPingAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useSendPingMutations = this.useSendPingMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useSendPingSetPendings)) {
        setPending(this.useSendPingMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameSendPingAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "SendPing",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useSendPingMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useSendPingSetPendings)) {
                  setPending(this.useSendPingMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useSendPingMutations =
            this.useSendPingMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useSendPingSetPendings)) {
              setPending(this.useSendPingMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameSendPingAborted.fromStatus(status);

            console.warn(
              `'Game.SendPing' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useSendPing(
    id: string,
    setPending: (mutations: PendingEmptyMutation[]) => void
  ) {
    this.useSendPingSetPendings[id] = setPending;
  }

  unuseSendPing(id: string) {
    delete this.useSendPingSetPendings[id];
  }


  private useUpdateSettingsMutations: (
    PendingGameUpdateSettingsRequestMutation)[] = [];

  private useUpdateSettingsSetPendings: {
    [id: string]: (mutations: PendingGameUpdateSettingsRequestMutation[]) => void
  } = {};

  async updateSettings(
    mutation: PendingGameUpdateSettingsRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameUpdateSettingsAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useUpdateSettingsMutations = this.useUpdateSettingsMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useUpdateSettingsSetPendings)) {
        setPending(this.useUpdateSettingsMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameUpdateSettingsAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "UpdateSettings",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useUpdateSettingsMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useUpdateSettingsSetPendings)) {
                  setPending(this.useUpdateSettingsMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useUpdateSettingsMutations =
            this.useUpdateSettingsMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useUpdateSettingsSetPendings)) {
              setPending(this.useUpdateSettingsMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameUpdateSettingsAborted.fromStatus(status);

            console.warn(
              `'Game.UpdateSettings' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useUpdateSettings(
    id: string,
    setPending: (mutations: PendingGameUpdateSettingsRequestMutation[]) => void
  ) {
    this.useUpdateSettingsSetPendings[id] = setPending;
  }

  unuseUpdateSettings(id: string) {
    delete this.useUpdateSettingsSetPendings[id];
  }


  private useDeleteTeamMutations: (
    PendingGameDeleteTeamRequestMutation)[] = [];

  private useDeleteTeamSetPendings: {
    [id: string]: (mutations: PendingGameDeleteTeamRequestMutation[]) => void
  } = {};

  async deleteTeam(
    mutation: PendingGameDeleteTeamRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameDeleteTeamAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useDeleteTeamMutations = this.useDeleteTeamMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useDeleteTeamSetPendings)) {
        setPending(this.useDeleteTeamMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameDeleteTeamAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "DeleteTeam",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useDeleteTeamMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useDeleteTeamSetPendings)) {
                  setPending(this.useDeleteTeamMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useDeleteTeamMutations =
            this.useDeleteTeamMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useDeleteTeamSetPendings)) {
              setPending(this.useDeleteTeamMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameDeleteTeamAborted.fromStatus(status);

            console.warn(
              `'Game.DeleteTeam' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useDeleteTeam(
    id: string,
    setPending: (mutations: PendingGameDeleteTeamRequestMutation[]) => void
  ) {
    this.useDeleteTeamSetPendings[id] = setPending;
  }

  unuseDeleteTeam(id: string) {
    delete this.useDeleteTeamSetPendings[id];
  }


  private useDeleteLocationMutations: (
    PendingGameDeleteLocationRequestMutation)[] = [];

  private useDeleteLocationSetPendings: {
    [id: string]: (mutations: PendingGameDeleteLocationRequestMutation[]) => void
  } = {};

  async deleteLocation(
    mutation: PendingGameDeleteLocationRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      GameDeleteLocationAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useDeleteLocationMutations = this.useDeleteLocationMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useDeleteLocationSetPendings)) {
        setPending(this.useDeleteLocationMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        GameDeleteLocationAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "DeleteLocation",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useDeleteLocationMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useDeleteLocationSetPendings)) {
                  setPending(this.useDeleteLocationMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useDeleteLocationMutations =
            this.useDeleteLocationMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useDeleteLocationSetPendings)) {
              setPending(this.useDeleteLocationMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = GameDeleteLocationAborted.fromStatus(status);

            console.warn(
              `'Game.DeleteLocation' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useDeleteLocation(
    id: string,
    setPending: (mutations: PendingGameDeleteLocationRequestMutation[]) => void
  ) {
    this.useDeleteLocationSetPendings[id] = setPending;
  }

  unuseDeleteLocation(id: string) {
    delete this.useDeleteLocationSetPendings[id];
  }


  private static instances: { [id: string]: GameInstance } = {};

  static use(id: string, stateRef: string, url: string) {
    if (!(id in this.instances)) {
      this.instances[id] = new GameInstance(id, stateRef, url);
    } else {
      this.instances[id].ref();
    }

    return this.instances[id];
  }

  unuse() {
    if (this.unref() === 0) {
      delete GameInstance.instances[this.id];
    }
  }
}

export const useGame = (
  { id }: { id: string }
): UseGameApi => {
  const stateId = id;
  const stateRef = reboot_api.stateIdToRef(
    "copenhunt.v1.Game",
    id,
  );

  const rebootClient = reboot_react.useRebootClient();

  const url = rebootClient.url;
  const bearerToken = rebootClient.bearerToken;

  const [instance, setInstance] = useState(() => {
    return GameInstance.use(
      stateId, stateRef, url
    );
  });

  if (instance.id !== stateId) {
    setInstance(
      GameInstance.use(
        stateId, stateRef, url
      )
    );
  }

  useEffect(() => {
    return () => {
      instance.unuse();
    };
  }, [instance]);

  const headers = useMemo(() => {
    const headers = new Headers();
    headers.set("Content-Type", "application/json");
    headers.append("Connection", "keep-alive");

    if (bearerToken !== undefined) {
      headers.append("Authorization", `Bearer ${bearerToken}`);
    }

    return headers;
  }, [bearerToken]);


  function useCreate() {
    const [
      pending,
      setPending
    ] = useState<PendingGameCreateRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useCreate(id, setPending);
      return () => {
        instance.unuseCreate(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const create = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<GameCreateRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof GameCreateRequest
          ? partialRequest.clone()
          : new GameCreateRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.create(mutation);
      };

      method.pending =
        new Array<PendingGameCreateRequestMutation>();

      return method;
    }, [bearerToken]);

    create.pending = pending;

    return create;
  }

  const create = useCreate();



  function useOverview(
    partialRequest: __bufbuildProtobufPartialMessage<GameOverviewRequest> = {}
  ) {
    const newRequest = partialRequest instanceof GameOverviewRequest
      ? partialRequest.clone()
      : new GameOverviewRequest(partialRequest);

    const [request, setRequest] = useState(newRequest);

    if (!request.equals(newRequest)) {
      setRequest(newRequest);
    }

    const [response, setResponse] = useState<GameOverviewResponse>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [aborted, setAborted] = useState<
      undefined
      | GameOverviewAborted
      >();

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    useEffect(() => {
      const id = uuidv4();
      instance.useOverview(
        id,
        request,
        bearerToken,
        (response: GameOverviewResponse) => {
          unstable_batchedUpdates(() => {
            setAborted(undefined);
            setResponse(response);
          });
        },
        setIsLoading,
        (status: reboot_api.Status) => {
          const aborted = GameOverviewAborted.fromStatus(status);

          console.warn(
            `'Game.Overview' aborted with ${aborted.message}`
          );

          setAborted(aborted);
        },
      );
      return () => {
        instance.unuseOverview(id, request, bearerToken);
      };
    }, [request, bearerToken]);

    return { response, isLoading, aborted };
  }

  async function overview(
    partialRequest: __bufbuildProtobufPartialMessage<GameOverviewRequest> = {},
    options?: { signal?: AbortSignal }
  ) {
    const request = partialRequest instanceof GameOverviewRequest
      ? partialRequest.clone()
      : new GameOverviewRequest(partialRequest);

    // Fetch with retry, using a backoff, i.e., if we get disconnected.
    const { response, aborted } = await (async () => {
      const backoff = new reboot_api.Backoff();

      while (true) {
        try {
          // Invariant here is that we use the '/package.service.method' path and
          // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
          //
          // See also 'reboot/helpers.py'.
          return {
            response: await reboot_web.guardedFetch(
              new Request(
                `${rebootClient.url}/__/reboot/rpc/${stateRef}/copenhunt.v1.GameMethods/Overview`, {
                  method: "POST",
                  headers,
                  body: request.toJsonString()
                }
              ),
              options
            )
          };
        } catch (e: unknown) {
          if (options?.signal?.aborted) {
            const aborted = new GameOverviewAborted(
              new reboot_api.errors_pb.Aborted(), {
                message: e instanceof Error
                  ? `${e}`
                  : `Unknown error: ${JSON.stringify(e)}`
              }
            );

            return { aborted };
          } else if (e instanceof Error) {
            console.error(e);
          } else {
            console.error(`Unknown error: ${JSON.stringify(e)}`);
          }
        }

        console.warn(`Retrying call to copenhunt.v1.GameMethods.Overview after backoff ...`);

        await backoff.wait();
      }
    })();

    if (aborted) {
      return { aborted };
    } else if (!response.ok) {
      if (response.headers.get("content-type") === "application/json") {
        const status = reboot_api.Status.fromJson(await response.json());

        const aborted = GameOverviewAborted.fromStatus(status);

        console.warn(
          `'Game.Overview' aborted with ${aborted.message}`
        );

        return { aborted };
      } else {
        const aborted = new GameOverviewAborted(
          new reboot_api.errors_pb.Unknown(), {
            message: `Unknown error with HTTP status ${response.status}`
          }
        );

        return { aborted };
      }
    } else {
      return { response: GameOverviewResponse.fromJson(await response.json()) };
    }
  }


  function useStart() {
    const [
      pending,
      setPending
    ] = useState<PendingEmptyMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useStart(id, setPending);
      return () => {
        instance.unuseStart(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const start = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<Empty> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof Empty
          ? partialRequest.clone()
          : new Empty(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.start(mutation);
      };

      method.pending =
        new Array<PendingEmptyMutation>();

      return method;
    }, [bearerToken]);

    start.pending = pending;

    return start;
  }

  const start = useStart();


  function usePause() {
    const [
      pending,
      setPending
    ] = useState<PendingEmptyMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.usePause(id, setPending);
      return () => {
        instance.unusePause(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const pause = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<Empty> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof Empty
          ? partialRequest.clone()
          : new Empty(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.pause(mutation);
      };

      method.pending =
        new Array<PendingEmptyMutation>();

      return method;
    }, [bearerToken]);

    pause.pending = pending;

    return pause;
  }

  const pause = usePause();


  function useUnpause() {
    const [
      pending,
      setPending
    ] = useState<PendingEmptyMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useUnpause(id, setPending);
      return () => {
        instance.unuseUnpause(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const unpause = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<Empty> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof Empty
          ? partialRequest.clone()
          : new Empty(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.unpause(mutation);
      };

      method.pending =
        new Array<PendingEmptyMutation>();

      return method;
    }, [bearerToken]);

    unpause.pending = pending;

    return unpause;
  }

  const unpause = useUnpause();


  function useCountdown() {
    const [
      pending,
      setPending
    ] = useState<PendingGameCountdownRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useCountdown(id, setPending);
      return () => {
        instance.unuseCountdown(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const countdown = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<GameCountdownRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof GameCountdownRequest
          ? partialRequest.clone()
          : new GameCountdownRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.countdown(mutation);
      };

      method.pending =
        new Array<PendingGameCountdownRequestMutation>();

      return method;
    }, [bearerToken]);

    countdown.pending = pending;

    return countdown;
  }

  const countdown = useCountdown();


  function useAddLocation() {
    const [
      pending,
      setPending
    ] = useState<PendingLocationInfoMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useAddLocation(id, setPending);
      return () => {
        instance.unuseAddLocation(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const addLocation = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<LocationInfo> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof LocationInfo
          ? partialRequest.clone()
          : new LocationInfo(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.addLocation(mutation);
      };

      method.pending =
        new Array<PendingLocationInfoMutation>();

      return method;
    }, [bearerToken]);

    addLocation.pending = pending;

    return addLocation;
  }

  const addLocation = useAddLocation();


  function useReleaseLocations() {
    const [
      pending,
      setPending
    ] = useState<PendingEmptyMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useReleaseLocations(id, setPending);
      return () => {
        instance.unuseReleaseLocations(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const releaseLocations = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<Empty> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof Empty
          ? partialRequest.clone()
          : new Empty(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.releaseLocations(mutation);
      };

      method.pending =
        new Array<PendingEmptyMutation>();

      return method;
    }, [bearerToken]);

    releaseLocations.pending = pending;

    return releaseLocations;
  }

  const releaseLocations = useReleaseLocations();


  function useAddChatIds() {
    const [
      pending,
      setPending
    ] = useState<PendingGameAddChatIdsRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useAddChatIds(id, setPending);
      return () => {
        instance.unuseAddChatIds(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const addChatIds = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<GameAddChatIdsRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof GameAddChatIdsRequest
          ? partialRequest.clone()
          : new GameAddChatIdsRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.addChatIds(mutation);
      };

      method.pending =
        new Array<PendingGameAddChatIdsRequestMutation>();

      return method;
    }, [bearerToken]);

    addChatIds.pending = pending;

    return addChatIds;
  }

  const addChatIds = useAddChatIds();



  function useTeamChatIds(
    partialRequest: __bufbuildProtobufPartialMessage<Empty> = {}
  ) {
    const newRequest = partialRequest instanceof Empty
      ? partialRequest.clone()
      : new Empty(partialRequest);

    const [request, setRequest] = useState(newRequest);

    if (!request.equals(newRequest)) {
      setRequest(newRequest);
    }

    const [response, setResponse] = useState<GameTeamChatIdsResponse>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [aborted, setAborted] = useState<
      undefined
      | GameTeamChatIdsAborted
      >();

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    useEffect(() => {
      const id = uuidv4();
      instance.useTeamChatIds(
        id,
        request,
        bearerToken,
        (response: GameTeamChatIdsResponse) => {
          unstable_batchedUpdates(() => {
            setAborted(undefined);
            setResponse(response);
          });
        },
        setIsLoading,
        (status: reboot_api.Status) => {
          const aborted = GameTeamChatIdsAborted.fromStatus(status);

          console.warn(
            `'Game.TeamChatIds' aborted with ${aborted.message}`
          );

          setAborted(aborted);
        },
      );
      return () => {
        instance.unuseTeamChatIds(id, request, bearerToken);
      };
    }, [request, bearerToken]);

    return { response, isLoading, aborted };
  }

  async function teamChatIds(
    partialRequest: __bufbuildProtobufPartialMessage<Empty> = {},
    options?: { signal?: AbortSignal }
  ) {
    const request = partialRequest instanceof Empty
      ? partialRequest.clone()
      : new Empty(partialRequest);

    // Fetch with retry, using a backoff, i.e., if we get disconnected.
    const { response, aborted } = await (async () => {
      const backoff = new reboot_api.Backoff();

      while (true) {
        try {
          // Invariant here is that we use the '/package.service.method' path and
          // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
          //
          // See also 'reboot/helpers.py'.
          return {
            response: await reboot_web.guardedFetch(
              new Request(
                `${rebootClient.url}/__/reboot/rpc/${stateRef}/copenhunt.v1.GameMethods/TeamChatIds`, {
                  method: "POST",
                  headers,
                  body: request.toJsonString()
                }
              ),
              options
            )
          };
        } catch (e: unknown) {
          if (options?.signal?.aborted) {
            const aborted = new GameTeamChatIdsAborted(
              new reboot_api.errors_pb.Aborted(), {
                message: e instanceof Error
                  ? `${e}`
                  : `Unknown error: ${JSON.stringify(e)}`
              }
            );

            return { aborted };
          } else if (e instanceof Error) {
            console.error(e);
          } else {
            console.error(`Unknown error: ${JSON.stringify(e)}`);
          }
        }

        console.warn(`Retrying call to copenhunt.v1.GameMethods.TeamChatIds after backoff ...`);

        await backoff.wait();
      }
    })();

    if (aborted) {
      return { aborted };
    } else if (!response.ok) {
      if (response.headers.get("content-type") === "application/json") {
        const status = reboot_api.Status.fromJson(await response.json());

        const aborted = GameTeamChatIdsAborted.fromStatus(status);

        console.warn(
          `'Game.TeamChatIds' aborted with ${aborted.message}`
        );

        return { aborted };
      } else {
        const aborted = new GameTeamChatIdsAborted(
          new reboot_api.errors_pb.Unknown(), {
            message: `Unknown error with HTTP status ${response.status}`
          }
        );

        return { aborted };
      }
    } else {
      return { response: GameTeamChatIdsResponse.fromJson(await response.json()) };
    }
  }


  function useBroadcast() {
    const [
      pending,
      setPending
    ] = useState<PendingGameBroadcastRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useBroadcast(id, setPending);
      return () => {
        instance.unuseBroadcast(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const broadcast = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<GameBroadcastRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof GameBroadcastRequest
          ? partialRequest.clone()
          : new GameBroadcastRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.broadcast(mutation);
      };

      method.pending =
        new Array<PendingGameBroadcastRequestMutation>();

      return method;
    }, [bearerToken]);

    broadcast.pending = pending;

    return broadcast;
  }

  const broadcast = useBroadcast();


  function useDeletePlayer() {
    const [
      pending,
      setPending
    ] = useState<PendingGameDeletePlayerRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useDeletePlayer(id, setPending);
      return () => {
        instance.unuseDeletePlayer(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const deletePlayer = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<GameDeletePlayerRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof GameDeletePlayerRequest
          ? partialRequest.clone()
          : new GameDeletePlayerRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.deletePlayer(mutation);
      };

      method.pending =
        new Array<PendingGameDeletePlayerRequestMutation>();

      return method;
    }, [bearerToken]);

    deletePlayer.pending = pending;

    return deletePlayer;
  }

  const deletePlayer = useDeletePlayer();


  function useRemoveObjective() {
    const [
      pending,
      setPending
    ] = useState<PendingGameRemoveObjectiveRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useRemoveObjective(id, setPending);
      return () => {
        instance.unuseRemoveObjective(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const removeObjective = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<GameRemoveObjectiveRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof GameRemoveObjectiveRequest
          ? partialRequest.clone()
          : new GameRemoveObjectiveRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.removeObjective(mutation);
      };

      method.pending =
        new Array<PendingGameRemoveObjectiveRequestMutation>();

      return method;
    }, [bearerToken]);

    removeObjective.pending = pending;

    return removeObjective;
  }

  const removeObjective = useRemoveObjective();


  function useSendPing() {
    const [
      pending,
      setPending
    ] = useState<PendingEmptyMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useSendPing(id, setPending);
      return () => {
        instance.unuseSendPing(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const sendPing = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<Empty> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof Empty
          ? partialRequest.clone()
          : new Empty(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.sendPing(mutation);
      };

      method.pending =
        new Array<PendingEmptyMutation>();

      return method;
    }, [bearerToken]);

    sendPing.pending = pending;

    return sendPing;
  }

  const sendPing = useSendPing();


  function useUpdateSettings() {
    const [
      pending,
      setPending
    ] = useState<PendingGameUpdateSettingsRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useUpdateSettings(id, setPending);
      return () => {
        instance.unuseUpdateSettings(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const updateSettings = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<GameUpdateSettingsRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof GameUpdateSettingsRequest
          ? partialRequest.clone()
          : new GameUpdateSettingsRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.updateSettings(mutation);
      };

      method.pending =
        new Array<PendingGameUpdateSettingsRequestMutation>();

      return method;
    }, [bearerToken]);

    updateSettings.pending = pending;

    return updateSettings;
  }

  const updateSettings = useUpdateSettings();


  function useDeleteTeam() {
    const [
      pending,
      setPending
    ] = useState<PendingGameDeleteTeamRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useDeleteTeam(id, setPending);
      return () => {
        instance.unuseDeleteTeam(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const deleteTeam = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<GameDeleteTeamRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof GameDeleteTeamRequest
          ? partialRequest.clone()
          : new GameDeleteTeamRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.deleteTeam(mutation);
      };

      method.pending =
        new Array<PendingGameDeleteTeamRequestMutation>();

      return method;
    }, [bearerToken]);

    deleteTeam.pending = pending;

    return deleteTeam;
  }

  const deleteTeam = useDeleteTeam();


  function useDeleteLocation() {
    const [
      pending,
      setPending
    ] = useState<PendingGameDeleteLocationRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useDeleteLocation(id, setPending);
      return () => {
        instance.unuseDeleteLocation(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const deleteLocation = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<GameDeleteLocationRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof GameDeleteLocationRequest
          ? partialRequest.clone()
          : new GameDeleteLocationRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.deleteLocation(mutation);
      };

      method.pending =
        new Array<PendingGameDeleteLocationRequestMutation>();

      return method;
    }, [bearerToken]);

    deleteLocation.pending = pending;

    return deleteLocation;
  }

  const deleteLocation = useDeleteLocation();


  return {
    mutators: {
      create,
      start,
      pause,
      unpause,
      countdown,
      addLocation,
      releaseLocations,
      addChatIds,
      broadcast,
      deletePlayer,
      removeObjective,
      sendPing,
      updateSettings,
      deleteTeam,
      deleteLocation,
    },
    create,
    overview,
    useOverview,
    start,
    pause,
    unpause,
    countdown,
    addLocation,
    releaseLocations,
    addChatIds,
    teamChatIds,
    useTeamChatIds,
    broadcast,
    deletePlayer,
    removeObjective,
    sendPing,
    updateSettings,
    deleteTeam,
    deleteLocation,
  };
};



export class Game {
  static State = GameProto;
}
export namespace Game {
  export type State = GameProto;
}

export interface SettingsParams {
  id: string;
  storeMutationsLocallyInNamespace?: string;
}

class TeamInstance {

  constructor(id: string, stateRef: string, url: string) {
    this.id = id;
    this.stateRef = stateRef;
    this.url = url;
    this.refs = 1;

     reboot_web.websockets.connect(this.url, this.stateRef);
    this.initializeWebSocket();
  }

  private ref() {
    this.refs += 1;
    return this.refs;
  }

  private unref() {
    this.refs -= 1;

    if (this.refs === 0 && this.websocket !== undefined) {
      this.websocket.close();
       reboot_web.websockets.disconnect(this.url, this.stateRef);
    }

    return this.refs;
  }

  readonly id: string;
  readonly stateRef: string;
  private url: string;
  private refs: number;
  private observers: reboot_react.Observers = {};
  private loadingReaders = 0;
  private runningMutates: reboot_react.Mutate[] = [];
  private queuedMutates: reboot_react.Mutate[] = [];
  private flushMutates?: reboot_api.Event = undefined;
  private websocket?: WebSocket = undefined;
  private backoff: reboot_api.Backoff = new reboot_api.Backoff();

  private hasRunningMutations() {
    return this.runningMutates.length > 0;
  }

  private async flushMutations() {
    if (this.flushMutates === undefined) {
      this.flushMutates = new reboot_api.Event();
    }
    await this.flushMutates.wait();
  }

  private readersLoadedOrFailed() {
    this.flushMutates = undefined;

    if (this.queuedMutates.length > 0) {
      this.runningMutates = this.queuedMutates;
      this.queuedMutates = [];

      if (this.websocket?.readyState === WebSocket.OPEN) {
        for (const { request, update } of this.runningMutates) {
          update({ isLoading: true });
          try {
            this.websocket.send(request.toBinary());
          } catch {
            // We'll retry since we've stored in `*Mutates`.
          }
        }
      }
    }
  }

  private initializeWebSocket() {
    if (this.websocket === undefined && this.refs > 0) {
      const url = new URL(`${this.url}/__/reboot/rpc/${this.stateRef}`);
      url.protocol = url.protocol === "https:" ? "wss:" : "ws:";

      this.websocket = reboot_web.websockets.create(url);

      this.websocket.binaryType = "arraybuffer";

      this.websocket.onopen = () => {
        if (this.websocket?.readyState === WebSocket.OPEN) {
          for (const { request, update } of this.runningMutates) {
            update({ isLoading: true });
            try {
              this.websocket.send(request.toBinary());
            } catch {
              // We'll retry since we've stored in `*Mutates`.
            }
          }
        }
      };

      this.websocket.onerror = async () => {
        if (this.websocket !== undefined) {
          this.websocket = undefined;

          for (const { update } of this.runningMutates) {
            update({ isLoading: false, error: "WebSocket disconnected" });
          }

          if (this.refs > 0) {
            if (this.runningMutates.length > 0) {
              console.warn(
                `WebSocket disconnected, ${this.runningMutates.length} outstanding mutations will be retried when we reconnect`
              );
            }

            await this.backoff.wait();

            this.initializeWebSocket();
          }
        }
      };

      this.websocket.onclose = async () => {
        if (this.websocket !== undefined) {
          this.websocket = undefined;

          for (const { update } of this.runningMutates) {
            update({ isLoading: false, error: "WebSocket disconnected" });
          }

          if (this.refs > 0) {
            await this.backoff.wait();

            this.initializeWebSocket();
          }
        }
      };

      this.websocket.onmessage = async (event) => {
        const { resolve } = this.runningMutates[0];
        this.runningMutates.shift();

        const response = reboot_api.react_pb.MutateResponse.fromBinary(
          new Uint8Array(event.data)
        );

        resolve(response);

        if (
          this.flushMutates !== undefined &&
          this.runningMutates.length === 0
        ) {
          this.flushMutates.set();
        }
      };
    }
  }

  private async mutate(
    partialRequest: __bufbuildProtobufPartialMessage<reboot_api.react_pb.MutateRequest>,
    update: (props: { isLoading: boolean; error?: any }) => void
  ): Promise<reboot_api.react_pb.MutateResponse> {
    const request = partialRequest instanceof reboot_api.react_pb.MutateRequest
      ? partialRequest
      : new reboot_api.react_pb.MutateRequest(partialRequest);

    return new Promise((resolve, _) => {
      if (this.loadingReaders === 0) {
        this.runningMutates = this.runningMutates.concat({ request, resolve, update });
        if (this.websocket?.readyState === WebSocket.OPEN) {
          update({ isLoading: true });
          try {
            this.websocket.send(request.toBinary());
          } catch {
            // We'll retry since we've stored in `*Mutates`.
          }
        }
      } else {
        this.queuedMutates = this.queuedMutates.concat({ request, resolve, update });
      }
    });
  }

  private async read<
    RequestType extends __bufbuildProtobufMessage<RequestType>,
    ResponseType extends __bufbuildProtobufMessage<ResponseType>,
    >(
    method: string,
    request: RequestType,
    bearerToken: string | undefined,
    responseType: __bufbuildProtobufMessageType<ResponseType>,
    reader: reboot_react.Reader<ResponseType>
  ) {
    const queryRequest = new reboot_api.react_pb.QueryRequest({
      method,
      request: request.toBinary(),
      ...(bearerToken !== undefined && { bearerToken } || {}),
    });

    // Expected idempotency key we should observe due to a mutation.
    interface Expected {
      // Idempotency key of mutation.
      idempotencyKey: string;

      // Callback when we've observed this idempotency key.
      observed: (callback: () => void) => Promise<void>;

      // Callback when we no longer care about observing.
      aborted: () => void;
    }

    let expecteds: Expected[] = [];

    // When we disconnect we may not be able to observe
    // responses due to mutations yet there may still be
    // some outstanding responses that are expected which
    // we treat as "orphans" in the sense that we won't
    // observe their idempotency keys but once we reconnect
    // we will still have observed their effects and can
    // call `observed()` on them.
    let orphans: Expected[] = [];

    const id = `${uuidv4()}`;

    this.observers[id] = {
      observe: (
        idempotencyKey: string,
        observed: (callback: () => void) => Promise<void>,
        aborted: () => void
      ) => {
        expecteds = expecteds.concat({ idempotencyKey, observed, aborted })
      },
      unobserve: (idempotencyKey: string) => {
        expecteds = expecteds.filter(
          expected => expected.idempotencyKey !== idempotencyKey
        );
      }
    };

    try {
      await reboot_api.retryForever(async () => {
        let loaded = false;
        this.loadingReaders += 1;

        // Any mutations started after we've incremented
        // `this.loadingReaders` will be queued until after
        // all the readers have loaded and thus (1) we know all
        // current `expected` are actually `orphans` that
        // we will haved "observed" once we are (re)connected
        // because we flush mutations before starting to read
        // and (2) all queued mutations can stay in `expected`
        // because we will in fact be able to observe them
        // since they won't get sent over the websocket
        // until after we are (re)connected.
        //
        // NOTE: we need to concatenate with `orphans`
        // because we may try to (re)connect multiple times
        // and between each try more mutations may have been
        // made (or queued ones will be moved to running).
        orphans = [...orphans, ...expecteds];
        expecteds = [];

        try {
          // Wait for potentially completed mutations to flush
          // before starting to read so that we read the latest
          // state including those mutations.
          if (this.hasRunningMutations()) {
            await this.flushMutations();
          }

          unstable_batchedUpdates(() => {
            for (const setIsLoading of Object.values(reader.setIsLoadings)) {
              setIsLoading(true);
            }
          });

          const queryResponses = reboot_web.reactiveReader({
            endpoint: `${this.url}/__/reboot/rpc/${this.stateRef}`,
            request: queryRequest,
            signal: reader.abortController.signal,
          });

          for await (const queryResponse of queryResponses) {
            if (!loaded) {
              if ((this.loadingReaders -= 1) === 0) {
                this.readersLoadedOrFailed();
              }
              loaded = true;
            }

            unstable_batchedUpdates(() => {
              for (const setIsLoading of Object.values(reader.setIsLoadings)) {
                setIsLoading(false);
              }
            });

            const response = queryResponse.responseOrStatus.case === "response"
              ? responseType.fromBinary(queryResponse.responseOrStatus.value)
              : undefined;

            // If we were disconnected it must be that we've
            // observed all `orphans` because we waited
            // for any mutations to flush before we re-started to
            // read.
            if (orphans.length > 0) {
              // We mark all mutations as observed except the
              // last one which we also invoke all `setResponse`s.
              // In this way we effectively create a barrier
              // for all readers that will synchronize on the last
              // mutation, but note that this still may lead
              // to some partial state/response updates because
              // one reader may have actually received a response
              // while another reader got disconnected. While this
              // is likely very rare, it is possible. Mitigating
              // this issue is non-trivial and for now we have
              // no plans to address it.
              for (let i = 0; i < orphans.length - 1; i++) {
                orphans[i].observed(() => {});
              }
              await orphans[orphans.length - 1].observed(() => {
                if (response !== undefined) {
                  reader.response = response;
                  for (const setResponse of Object.values(reader.setResponses)) {
                    setResponse(response);
                  }
                }
              });

              orphans = [];
            } else if (
              expecteds.length > 0 &&
              queryResponse.idempotencyKeys.includes(
                expecteds[0].idempotencyKey
              )
            ) {
              await expecteds[0].observed(() => {
                if (response !== undefined) {
                  reader.response = response;
                  for (const setResponse of Object.values(reader.setResponses)) {
                    setResponse(response);
                  }
                }
                expecteds.shift();
              });
            } else if (response !== undefined) {
              unstable_batchedUpdates(() => {
                reader.response = response;
                for (const setResponse of Object.values(reader.setResponses)) {
                  setResponse(response);
                }
              });
            }
          }

          throw new Error('Not expecting stream to ever be done');
        } catch (e: unknown) {
          if (!loaded) {
            if ((this.loadingReaders -= 1) === 0) {
              this.readersLoadedOrFailed();
            }
          }

          loaded = false;

          if (reader.abortController.signal.aborted) {
            for (const { aborted } of [...orphans, ...expecteds]) {
              aborted();
            }
            return;
          }

          unstable_batchedUpdates(() => {
            for (const setIsLoading of Object.values(reader.setIsLoadings)) {
              setIsLoading(false);
            }
            for (const setStatus of Object.values(reader.setStatuses)) {
              if (e instanceof reboot_api.Status) {
                setStatus(e);
              } else {
                setStatus(
                  new reboot_api.Status({
                    code: reboot_api.StatusCode.UNKNOWN,
                    message: e instanceof Error
                      ? e.message
                      : JSON.stringify(e),
                  })
                );
              }
            }
          });

          throw e; // This just retries!
        }
      });
    } finally {
      delete this.observers[id];
    }
  }


  private useCreateMutations: (
    PendingTeamCreateRequestMutation)[] = [];

  private useCreateSetPendings: {
    [id: string]: (mutations: PendingTeamCreateRequestMutation[]) => void
  } = {};

  async create(
    mutation: PendingTeamCreateRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      TeamCreateResponse,
      TeamCreateAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useCreateMutations = this.useCreateMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useCreateSetPendings)) {
        setPending(this.useCreateMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        TeamCreateResponse,
        TeamCreateAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "Create",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useCreateMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useCreateSetPendings)) {
                  setPending(this.useCreateMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useCreateMutations =
            this.useCreateMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useCreateSetPendings)) {
              setPending(this.useCreateMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: TeamCreateResponse.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = TeamCreateAborted.fromStatus(status);

            console.warn(
              `'Team.Create' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useCreate(
    id: string,
    setPending: (mutations: PendingTeamCreateRequestMutation[]) => void
  ) {
    this.useCreateSetPendings[id] = setPending;
  }

  unuseCreate(id: string) {
    delete this.useCreateSetPendings[id];
  }


  private useJoinMutations: (
    PendingTeamJoinRequestMutation)[] = [];

  private useJoinSetPendings: {
    [id: string]: (mutations: PendingTeamJoinRequestMutation[]) => void
  } = {};

  async join(
    mutation: PendingTeamJoinRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      TeamJoinResponse,
      TeamJoinAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useJoinMutations = this.useJoinMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useJoinSetPendings)) {
        setPending(this.useJoinMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        TeamJoinResponse,
        TeamJoinAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "Join",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useJoinMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useJoinSetPendings)) {
                  setPending(this.useJoinMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useJoinMutations =
            this.useJoinMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useJoinSetPendings)) {
              setPending(this.useJoinMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: TeamJoinResponse.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = TeamJoinAborted.fromStatus(status);

            console.warn(
              `'Team.Join' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useJoin(
    id: string,
    setPending: (mutations: PendingTeamJoinRequestMutation[]) => void
  ) {
    this.useJoinSetPendings[id] = setPending;
  }

  unuseJoin(id: string) {
    delete this.useJoinSetPendings[id];
  }


  private usePlayersReaders: {
    [id: string]: reboot_react.Reader<PlayersResponse>
  } = {};

  usePlayers(
    id: string,
    request: PlayersRequest,
    bearerToken: string | undefined,
    setResponse: (response: PlayersResponse) => void,
    setIsLoading: (isLoading: boolean) => void,
    setStatus: (status: reboot_api.Status) => void
  ) {
    let read = false;

    // NOTE: need to concatenate `request.toJsonString()` with `bearerToken`
    // because it uniquely identifies the request, i.e., a second call
    // that has the same `request` but a different bearerToken should be a
    // different call.
    const key = request.toJsonString() + bearerToken;

    if (!(key in this.usePlayersReaders)) {
      this.usePlayersReaders[key] = {
        abortController: new AbortController(),
        setResponses: {},
        setIsLoadings: {},
        setStatuses: {},
      };

      read = true;
    }

    let reader = this.usePlayersReaders[key];

    reader.setResponses[id] = setResponse;
    reader.setIsLoadings[id] = setIsLoading;
    reader.setStatuses[id] = setStatus;

    if (reader.response !== undefined) {
      setResponse(reader.response);
    }

    if (read) {
      this.read(
        "Players",
        request,
        bearerToken,
        PlayersResponse,
        reader
      );
    }
  }

  unusePlayers(
    id: string,
    request: PlayersRequest,
    bearerToken: string | undefined
  ) {
    // See comment above in `usePlayers` for why
    // we concatenate `request.toJsonString()` with `bearerToken`.
    const key = request.toJsonString() + bearerToken;

    const reader = this.usePlayersReaders[key];

    delete reader.setResponses[id];
    delete reader.setIsLoadings[id];
    delete reader.setStatuses[id];

    if (Object.values(reader.setResponses).length === 0) {
      delete this.usePlayersReaders[key];
      reader.abortController.abort();
    }
  }


  private useInfoReaders: {
    [id: string]: reboot_react.Reader<TeamInfoResponse>
  } = {};

  useInfo(
    id: string,
    request: TeamInfoRequest,
    bearerToken: string | undefined,
    setResponse: (response: TeamInfoResponse) => void,
    setIsLoading: (isLoading: boolean) => void,
    setStatus: (status: reboot_api.Status) => void
  ) {
    let read = false;

    // NOTE: need to concatenate `request.toJsonString()` with `bearerToken`
    // because it uniquely identifies the request, i.e., a second call
    // that has the same `request` but a different bearerToken should be a
    // different call.
    const key = request.toJsonString() + bearerToken;

    if (!(key in this.useInfoReaders)) {
      this.useInfoReaders[key] = {
        abortController: new AbortController(),
        setResponses: {},
        setIsLoadings: {},
        setStatuses: {},
      };

      read = true;
    }

    let reader = this.useInfoReaders[key];

    reader.setResponses[id] = setResponse;
    reader.setIsLoadings[id] = setIsLoading;
    reader.setStatuses[id] = setStatus;

    if (reader.response !== undefined) {
      setResponse(reader.response);
    }

    if (read) {
      this.read(
        "Info",
        request,
        bearerToken,
        TeamInfoResponse,
        reader
      );
    }
  }

  unuseInfo(
    id: string,
    request: TeamInfoRequest,
    bearerToken: string | undefined
  ) {
    // See comment above in `useInfo` for why
    // we concatenate `request.toJsonString()` with `bearerToken`.
    const key = request.toJsonString() + bearerToken;

    const reader = this.useInfoReaders[key];

    delete reader.setResponses[id];
    delete reader.setIsLoadings[id];
    delete reader.setStatuses[id];

    if (Object.values(reader.setResponses).length === 0) {
      delete this.useInfoReaders[key];
      reader.abortController.abort();
    }
  }


  private useAddChatIdMutations: (
    PendingTeamAddChatIdRequestMutation)[] = [];

  private useAddChatIdSetPendings: {
    [id: string]: (mutations: PendingTeamAddChatIdRequestMutation[]) => void
  } = {};

  async addChatId(
    mutation: PendingTeamAddChatIdRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      TeamAddChatIdAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useAddChatIdMutations = this.useAddChatIdMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useAddChatIdSetPendings)) {
        setPending(this.useAddChatIdMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamAddChatIdAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "AddChatId",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useAddChatIdMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useAddChatIdSetPendings)) {
                  setPending(this.useAddChatIdMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useAddChatIdMutations =
            this.useAddChatIdMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useAddChatIdSetPendings)) {
              setPending(this.useAddChatIdMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = TeamAddChatIdAborted.fromStatus(status);

            console.warn(
              `'Team.AddChatId' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useAddChatId(
    id: string,
    setPending: (mutations: PendingTeamAddChatIdRequestMutation[]) => void
  ) {
    this.useAddChatIdSetPendings[id] = setPending;
  }

  unuseAddChatId(id: string) {
    delete this.useAddChatIdSetPendings[id];
  }


  private useDeletePlayerMutations: (
    PendingTeamDeletePlayerRequestMutation)[] = [];

  private useDeletePlayerSetPendings: {
    [id: string]: (mutations: PendingTeamDeletePlayerRequestMutation[]) => void
  } = {};

  async deletePlayer(
    mutation: PendingTeamDeletePlayerRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      TeamDeletePlayerAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useDeletePlayerMutations = this.useDeletePlayerMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useDeletePlayerSetPendings)) {
        setPending(this.useDeletePlayerMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamDeletePlayerAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "DeletePlayer",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useDeletePlayerMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useDeletePlayerSetPendings)) {
                  setPending(this.useDeletePlayerMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useDeletePlayerMutations =
            this.useDeletePlayerMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useDeletePlayerSetPendings)) {
              setPending(this.useDeletePlayerMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = TeamDeletePlayerAborted.fromStatus(status);

            console.warn(
              `'Team.DeletePlayer' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useDeletePlayer(
    id: string,
    setPending: (mutations: PendingTeamDeletePlayerRequestMutation[]) => void
  ) {
    this.useDeletePlayerSetPendings[id] = setPending;
  }

  unuseDeletePlayer(id: string) {
    delete this.useDeletePlayerSetPendings[id];
  }


  private useGrabObjectiveMutations: (
    PendingTeamGrabObjectiveRequestMutation)[] = [];

  private useGrabObjectiveSetPendings: {
    [id: string]: (mutations: PendingTeamGrabObjectiveRequestMutation[]) => void
  } = {};

  async grabObjective(
    mutation: PendingTeamGrabObjectiveRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      TeamGrabObjectiveAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useGrabObjectiveMutations = this.useGrabObjectiveMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useGrabObjectiveSetPendings)) {
        setPending(this.useGrabObjectiveMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamGrabObjectiveAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "GrabObjective",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useGrabObjectiveMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useGrabObjectiveSetPendings)) {
                  setPending(this.useGrabObjectiveMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useGrabObjectiveMutations =
            this.useGrabObjectiveMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useGrabObjectiveSetPendings)) {
              setPending(this.useGrabObjectiveMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = TeamGrabObjectiveAborted.fromStatus(status);

            console.warn(
              `'Team.GrabObjective' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useGrabObjective(
    id: string,
    setPending: (mutations: PendingTeamGrabObjectiveRequestMutation[]) => void
  ) {
    this.useGrabObjectiveSetPendings[id] = setPending;
  }

  unuseGrabObjective(id: string) {
    delete this.useGrabObjectiveSetPendings[id];
  }


  private useCurrentObjectiveReaders: {
    [id: string]: reboot_react.Reader<TeamCurrentObjectiveResponse>
  } = {};

  useCurrentObjective(
    id: string,
    request: Empty,
    bearerToken: string | undefined,
    setResponse: (response: TeamCurrentObjectiveResponse) => void,
    setIsLoading: (isLoading: boolean) => void,
    setStatus: (status: reboot_api.Status) => void
  ) {
    let read = false;

    // NOTE: need to concatenate `request.toJsonString()` with `bearerToken`
    // because it uniquely identifies the request, i.e., a second call
    // that has the same `request` but a different bearerToken should be a
    // different call.
    const key = request.toJsonString() + bearerToken;

    if (!(key in this.useCurrentObjectiveReaders)) {
      this.useCurrentObjectiveReaders[key] = {
        abortController: new AbortController(),
        setResponses: {},
        setIsLoadings: {},
        setStatuses: {},
      };

      read = true;
    }

    let reader = this.useCurrentObjectiveReaders[key];

    reader.setResponses[id] = setResponse;
    reader.setIsLoadings[id] = setIsLoading;
    reader.setStatuses[id] = setStatus;

    if (reader.response !== undefined) {
      setResponse(reader.response);
    }

    if (read) {
      this.read(
        "CurrentObjective",
        request,
        bearerToken,
        TeamCurrentObjectiveResponse,
        reader
      );
    }
  }

  unuseCurrentObjective(
    id: string,
    request: Empty,
    bearerToken: string | undefined
  ) {
    // See comment above in `useCurrentObjective` for why
    // we concatenate `request.toJsonString()` with `bearerToken`.
    const key = request.toJsonString() + bearerToken;

    const reader = this.useCurrentObjectiveReaders[key];

    delete reader.setResponses[id];
    delete reader.setIsLoadings[id];
    delete reader.setStatuses[id];

    if (Object.values(reader.setResponses).length === 0) {
      delete this.useCurrentObjectiveReaders[key];
      reader.abortController.abort();
    }
  }


  private useRemoveObjectiveMutations: (
    PendingTeamRemoveObjectiveRequestMutation)[] = [];

  private useRemoveObjectiveSetPendings: {
    [id: string]: (mutations: PendingTeamRemoveObjectiveRequestMutation[]) => void
  } = {};

  async removeObjective(
    mutation: PendingTeamRemoveObjectiveRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      TeamRemoveObjectiveAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useRemoveObjectiveMutations = this.useRemoveObjectiveMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useRemoveObjectiveSetPendings)) {
        setPending(this.useRemoveObjectiveMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamRemoveObjectiveAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "RemoveObjective",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useRemoveObjectiveMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useRemoveObjectiveSetPendings)) {
                  setPending(this.useRemoveObjectiveMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useRemoveObjectiveMutations =
            this.useRemoveObjectiveMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useRemoveObjectiveSetPendings)) {
              setPending(this.useRemoveObjectiveMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = TeamRemoveObjectiveAborted.fromStatus(status);

            console.warn(
              `'Team.RemoveObjective' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useRemoveObjective(
    id: string,
    setPending: (mutations: PendingTeamRemoveObjectiveRequestMutation[]) => void
  ) {
    this.useRemoveObjectiveSetPendings[id] = setPending;
  }

  unuseRemoveObjective(id: string) {
    delete this.useRemoveObjectiveSetPendings[id];
  }


  private useSendPingMutations: (
    PendingEmptyMutation)[] = [];

  private useSendPingSetPendings: {
    [id: string]: (mutations: PendingEmptyMutation[]) => void
  } = {};

  async sendPing(
    mutation: PendingEmptyMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      TeamSendPingAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useSendPingMutations = this.useSendPingMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useSendPingSetPendings)) {
        setPending(this.useSendPingMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamSendPingAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "SendPing",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useSendPingMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useSendPingSetPendings)) {
                  setPending(this.useSendPingMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useSendPingMutations =
            this.useSendPingMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useSendPingSetPendings)) {
              setPending(this.useSendPingMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = TeamSendPingAborted.fromStatus(status);

            console.warn(
              `'Team.SendPing' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useSendPing(
    id: string,
    setPending: (mutations: PendingEmptyMutation[]) => void
  ) {
    this.useSendPingSetPendings[id] = setPending;
  }

  unuseSendPing(id: string) {
    delete this.useSendPingSetPendings[id];
  }


  private useSetExtraPingsMutations: (
    PendingTeamSetExtraPingsRequestMutation)[] = [];

  private useSetExtraPingsSetPendings: {
    [id: string]: (mutations: PendingTeamSetExtraPingsRequestMutation[]) => void
  } = {};

  async setExtraPings(
    mutation: PendingTeamSetExtraPingsRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      TeamSetExtraPingsAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useSetExtraPingsMutations = this.useSetExtraPingsMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useSetExtraPingsSetPendings)) {
        setPending(this.useSetExtraPingsMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        TeamSetExtraPingsAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "SetExtraPings",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useSetExtraPingsMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useSetExtraPingsSetPendings)) {
                  setPending(this.useSetExtraPingsMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useSetExtraPingsMutations =
            this.useSetExtraPingsMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useSetExtraPingsSetPendings)) {
              setPending(this.useSetExtraPingsMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = TeamSetExtraPingsAborted.fromStatus(status);

            console.warn(
              `'Team.SetExtraPings' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useSetExtraPings(
    id: string,
    setPending: (mutations: PendingTeamSetExtraPingsRequestMutation[]) => void
  ) {
    this.useSetExtraPingsSetPendings[id] = setPending;
  }

  unuseSetExtraPings(id: string) {
    delete this.useSetExtraPingsSetPendings[id];
  }


  private static instances: { [id: string]: TeamInstance } = {};

  static use(id: string, stateRef: string, url: string) {
    if (!(id in this.instances)) {
      this.instances[id] = new TeamInstance(id, stateRef, url);
    } else {
      this.instances[id].ref();
    }

    return this.instances[id];
  }

  unuse() {
    if (this.unref() === 0) {
      delete TeamInstance.instances[this.id];
    }
  }
}

export const useTeam = (
  { id }: { id: string }
): UseTeamApi => {
  const stateId = id;
  const stateRef = reboot_api.stateIdToRef(
    "copenhunt.v1.Team",
    id,
  );

  const rebootClient = reboot_react.useRebootClient();

  const url = rebootClient.url;
  const bearerToken = rebootClient.bearerToken;

  const [instance, setInstance] = useState(() => {
    return TeamInstance.use(
      stateId, stateRef, url
    );
  });

  if (instance.id !== stateId) {
    setInstance(
      TeamInstance.use(
        stateId, stateRef, url
      )
    );
  }

  useEffect(() => {
    return () => {
      instance.unuse();
    };
  }, [instance]);

  const headers = useMemo(() => {
    const headers = new Headers();
    headers.set("Content-Type", "application/json");
    headers.append("Connection", "keep-alive");

    if (bearerToken !== undefined) {
      headers.append("Authorization", `Bearer ${bearerToken}`);
    }

    return headers;
  }, [bearerToken]);


  function useCreate() {
    const [
      pending,
      setPending
    ] = useState<PendingTeamCreateRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useCreate(id, setPending);
      return () => {
        instance.unuseCreate(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const create = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<TeamCreateRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof TeamCreateRequest
          ? partialRequest.clone()
          : new TeamCreateRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.create(mutation);
      };

      method.pending =
        new Array<PendingTeamCreateRequestMutation>();

      return method;
    }, [bearerToken]);

    create.pending = pending;

    return create;
  }

  const create = useCreate();


  function useJoin() {
    const [
      pending,
      setPending
    ] = useState<PendingTeamJoinRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useJoin(id, setPending);
      return () => {
        instance.unuseJoin(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const join = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<TeamJoinRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof TeamJoinRequest
          ? partialRequest.clone()
          : new TeamJoinRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.join(mutation);
      };

      method.pending =
        new Array<PendingTeamJoinRequestMutation>();

      return method;
    }, [bearerToken]);

    join.pending = pending;

    return join;
  }

  const join = useJoin();



  function usePlayers(
    partialRequest: __bufbuildProtobufPartialMessage<PlayersRequest> = {}
  ) {
    const newRequest = partialRequest instanceof PlayersRequest
      ? partialRequest.clone()
      : new PlayersRequest(partialRequest);

    const [request, setRequest] = useState(newRequest);

    if (!request.equals(newRequest)) {
      setRequest(newRequest);
    }

    const [response, setResponse] = useState<PlayersResponse>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [aborted, setAborted] = useState<
      undefined
      | TeamPlayersAborted
      >();

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    useEffect(() => {
      const id = uuidv4();
      instance.usePlayers(
        id,
        request,
        bearerToken,
        (response: PlayersResponse) => {
          unstable_batchedUpdates(() => {
            setAborted(undefined);
            setResponse(response);
          });
        },
        setIsLoading,
        (status: reboot_api.Status) => {
          const aborted = TeamPlayersAborted.fromStatus(status);

          console.warn(
            `'Team.Players' aborted with ${aborted.message}`
          );

          setAborted(aborted);
        },
      );
      return () => {
        instance.unusePlayers(id, request, bearerToken);
      };
    }, [request, bearerToken]);

    return { response, isLoading, aborted };
  }

  async function players(
    partialRequest: __bufbuildProtobufPartialMessage<PlayersRequest> = {},
    options?: { signal?: AbortSignal }
  ) {
    const request = partialRequest instanceof PlayersRequest
      ? partialRequest.clone()
      : new PlayersRequest(partialRequest);

    // Fetch with retry, using a backoff, i.e., if we get disconnected.
    const { response, aborted } = await (async () => {
      const backoff = new reboot_api.Backoff();

      while (true) {
        try {
          // Invariant here is that we use the '/package.service.method' path and
          // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
          //
          // See also 'reboot/helpers.py'.
          return {
            response: await reboot_web.guardedFetch(
              new Request(
                `${rebootClient.url}/__/reboot/rpc/${stateRef}/copenhunt.v1.TeamMethods/Players`, {
                  method: "POST",
                  headers,
                  body: request.toJsonString()
                }
              ),
              options
            )
          };
        } catch (e: unknown) {
          if (options?.signal?.aborted) {
            const aborted = new TeamPlayersAborted(
              new reboot_api.errors_pb.Aborted(), {
                message: e instanceof Error
                  ? `${e}`
                  : `Unknown error: ${JSON.stringify(e)}`
              }
            );

            return { aborted };
          } else if (e instanceof Error) {
            console.error(e);
          } else {
            console.error(`Unknown error: ${JSON.stringify(e)}`);
          }
        }

        console.warn(`Retrying call to copenhunt.v1.TeamMethods.Players after backoff ...`);

        await backoff.wait();
      }
    })();

    if (aborted) {
      return { aborted };
    } else if (!response.ok) {
      if (response.headers.get("content-type") === "application/json") {
        const status = reboot_api.Status.fromJson(await response.json());

        const aborted = TeamPlayersAborted.fromStatus(status);

        console.warn(
          `'Team.Players' aborted with ${aborted.message}`
        );

        return { aborted };
      } else {
        const aborted = new TeamPlayersAborted(
          new reboot_api.errors_pb.Unknown(), {
            message: `Unknown error with HTTP status ${response.status}`
          }
        );

        return { aborted };
      }
    } else {
      return { response: PlayersResponse.fromJson(await response.json()) };
    }
  }



  function useInfo(
    partialRequest: __bufbuildProtobufPartialMessage<TeamInfoRequest> = {}
  ) {
    const newRequest = partialRequest instanceof TeamInfoRequest
      ? partialRequest.clone()
      : new TeamInfoRequest(partialRequest);

    const [request, setRequest] = useState(newRequest);

    if (!request.equals(newRequest)) {
      setRequest(newRequest);
    }

    const [response, setResponse] = useState<TeamInfoResponse>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [aborted, setAborted] = useState<
      undefined
      | TeamInfoAborted
      >();

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    useEffect(() => {
      const id = uuidv4();
      instance.useInfo(
        id,
        request,
        bearerToken,
        (response: TeamInfoResponse) => {
          unstable_batchedUpdates(() => {
            setAborted(undefined);
            setResponse(response);
          });
        },
        setIsLoading,
        (status: reboot_api.Status) => {
          const aborted = TeamInfoAborted.fromStatus(status);

          console.warn(
            `'Team.Info' aborted with ${aborted.message}`
          );

          setAborted(aborted);
        },
      );
      return () => {
        instance.unuseInfo(id, request, bearerToken);
      };
    }, [request, bearerToken]);

    return { response, isLoading, aborted };
  }

  async function info(
    partialRequest: __bufbuildProtobufPartialMessage<TeamInfoRequest> = {},
    options?: { signal?: AbortSignal }
  ) {
    const request = partialRequest instanceof TeamInfoRequest
      ? partialRequest.clone()
      : new TeamInfoRequest(partialRequest);

    // Fetch with retry, using a backoff, i.e., if we get disconnected.
    const { response, aborted } = await (async () => {
      const backoff = new reboot_api.Backoff();

      while (true) {
        try {
          // Invariant here is that we use the '/package.service.method' path and
          // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
          //
          // See also 'reboot/helpers.py'.
          return {
            response: await reboot_web.guardedFetch(
              new Request(
                `${rebootClient.url}/__/reboot/rpc/${stateRef}/copenhunt.v1.TeamMethods/Info`, {
                  method: "POST",
                  headers,
                  body: request.toJsonString()
                }
              ),
              options
            )
          };
        } catch (e: unknown) {
          if (options?.signal?.aborted) {
            const aborted = new TeamInfoAborted(
              new reboot_api.errors_pb.Aborted(), {
                message: e instanceof Error
                  ? `${e}`
                  : `Unknown error: ${JSON.stringify(e)}`
              }
            );

            return { aborted };
          } else if (e instanceof Error) {
            console.error(e);
          } else {
            console.error(`Unknown error: ${JSON.stringify(e)}`);
          }
        }

        console.warn(`Retrying call to copenhunt.v1.TeamMethods.Info after backoff ...`);

        await backoff.wait();
      }
    })();

    if (aborted) {
      return { aborted };
    } else if (!response.ok) {
      if (response.headers.get("content-type") === "application/json") {
        const status = reboot_api.Status.fromJson(await response.json());

        const aborted = TeamInfoAborted.fromStatus(status);

        console.warn(
          `'Team.Info' aborted with ${aborted.message}`
        );

        return { aborted };
      } else {
        const aborted = new TeamInfoAborted(
          new reboot_api.errors_pb.Unknown(), {
            message: `Unknown error with HTTP status ${response.status}`
          }
        );

        return { aborted };
      }
    } else {
      return { response: TeamInfoResponse.fromJson(await response.json()) };
    }
  }


  function useAddChatId() {
    const [
      pending,
      setPending
    ] = useState<PendingTeamAddChatIdRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useAddChatId(id, setPending);
      return () => {
        instance.unuseAddChatId(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const addChatId = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<TeamAddChatIdRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof TeamAddChatIdRequest
          ? partialRequest.clone()
          : new TeamAddChatIdRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.addChatId(mutation);
      };

      method.pending =
        new Array<PendingTeamAddChatIdRequestMutation>();

      return method;
    }, [bearerToken]);

    addChatId.pending = pending;

    return addChatId;
  }

  const addChatId = useAddChatId();


  function useDeletePlayer() {
    const [
      pending,
      setPending
    ] = useState<PendingTeamDeletePlayerRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useDeletePlayer(id, setPending);
      return () => {
        instance.unuseDeletePlayer(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const deletePlayer = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<TeamDeletePlayerRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof TeamDeletePlayerRequest
          ? partialRequest.clone()
          : new TeamDeletePlayerRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.deletePlayer(mutation);
      };

      method.pending =
        new Array<PendingTeamDeletePlayerRequestMutation>();

      return method;
    }, [bearerToken]);

    deletePlayer.pending = pending;

    return deletePlayer;
  }

  const deletePlayer = useDeletePlayer();


  function useGrabObjective() {
    const [
      pending,
      setPending
    ] = useState<PendingTeamGrabObjectiveRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useGrabObjective(id, setPending);
      return () => {
        instance.unuseGrabObjective(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const grabObjective = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<TeamGrabObjectiveRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof TeamGrabObjectiveRequest
          ? partialRequest.clone()
          : new TeamGrabObjectiveRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.grabObjective(mutation);
      };

      method.pending =
        new Array<PendingTeamGrabObjectiveRequestMutation>();

      return method;
    }, [bearerToken]);

    grabObjective.pending = pending;

    return grabObjective;
  }

  const grabObjective = useGrabObjective();



  function useCurrentObjective(
    partialRequest: __bufbuildProtobufPartialMessage<Empty> = {}
  ) {
    const newRequest = partialRequest instanceof Empty
      ? partialRequest.clone()
      : new Empty(partialRequest);

    const [request, setRequest] = useState(newRequest);

    if (!request.equals(newRequest)) {
      setRequest(newRequest);
    }

    const [response, setResponse] = useState<TeamCurrentObjectiveResponse>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [aborted, setAborted] = useState<
      undefined
      | TeamCurrentObjectiveAborted
      >();

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    useEffect(() => {
      const id = uuidv4();
      instance.useCurrentObjective(
        id,
        request,
        bearerToken,
        (response: TeamCurrentObjectiveResponse) => {
          unstable_batchedUpdates(() => {
            setAborted(undefined);
            setResponse(response);
          });
        },
        setIsLoading,
        (status: reboot_api.Status) => {
          const aborted = TeamCurrentObjectiveAborted.fromStatus(status);

          console.warn(
            `'Team.CurrentObjective' aborted with ${aborted.message}`
          );

          setAborted(aborted);
        },
      );
      return () => {
        instance.unuseCurrentObjective(id, request, bearerToken);
      };
    }, [request, bearerToken]);

    return { response, isLoading, aborted };
  }

  async function currentObjective(
    partialRequest: __bufbuildProtobufPartialMessage<Empty> = {},
    options?: { signal?: AbortSignal }
  ) {
    const request = partialRequest instanceof Empty
      ? partialRequest.clone()
      : new Empty(partialRequest);

    // Fetch with retry, using a backoff, i.e., if we get disconnected.
    const { response, aborted } = await (async () => {
      const backoff = new reboot_api.Backoff();

      while (true) {
        try {
          // Invariant here is that we use the '/package.service.method' path and
          // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
          //
          // See also 'reboot/helpers.py'.
          return {
            response: await reboot_web.guardedFetch(
              new Request(
                `${rebootClient.url}/__/reboot/rpc/${stateRef}/copenhunt.v1.TeamMethods/CurrentObjective`, {
                  method: "POST",
                  headers,
                  body: request.toJsonString()
                }
              ),
              options
            )
          };
        } catch (e: unknown) {
          if (options?.signal?.aborted) {
            const aborted = new TeamCurrentObjectiveAborted(
              new reboot_api.errors_pb.Aborted(), {
                message: e instanceof Error
                  ? `${e}`
                  : `Unknown error: ${JSON.stringify(e)}`
              }
            );

            return { aborted };
          } else if (e instanceof Error) {
            console.error(e);
          } else {
            console.error(`Unknown error: ${JSON.stringify(e)}`);
          }
        }

        console.warn(`Retrying call to copenhunt.v1.TeamMethods.CurrentObjective after backoff ...`);

        await backoff.wait();
      }
    })();

    if (aborted) {
      return { aborted };
    } else if (!response.ok) {
      if (response.headers.get("content-type") === "application/json") {
        const status = reboot_api.Status.fromJson(await response.json());

        const aborted = TeamCurrentObjectiveAborted.fromStatus(status);

        console.warn(
          `'Team.CurrentObjective' aborted with ${aborted.message}`
        );

        return { aborted };
      } else {
        const aborted = new TeamCurrentObjectiveAborted(
          new reboot_api.errors_pb.Unknown(), {
            message: `Unknown error with HTTP status ${response.status}`
          }
        );

        return { aborted };
      }
    } else {
      return { response: TeamCurrentObjectiveResponse.fromJson(await response.json()) };
    }
  }


  function useRemoveObjective() {
    const [
      pending,
      setPending
    ] = useState<PendingTeamRemoveObjectiveRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useRemoveObjective(id, setPending);
      return () => {
        instance.unuseRemoveObjective(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const removeObjective = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<TeamRemoveObjectiveRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof TeamRemoveObjectiveRequest
          ? partialRequest.clone()
          : new TeamRemoveObjectiveRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.removeObjective(mutation);
      };

      method.pending =
        new Array<PendingTeamRemoveObjectiveRequestMutation>();

      return method;
    }, [bearerToken]);

    removeObjective.pending = pending;

    return removeObjective;
  }

  const removeObjective = useRemoveObjective();


  function useSendPing() {
    const [
      pending,
      setPending
    ] = useState<PendingEmptyMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useSendPing(id, setPending);
      return () => {
        instance.unuseSendPing(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const sendPing = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<Empty> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof Empty
          ? partialRequest.clone()
          : new Empty(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.sendPing(mutation);
      };

      method.pending =
        new Array<PendingEmptyMutation>();

      return method;
    }, [bearerToken]);

    sendPing.pending = pending;

    return sendPing;
  }

  const sendPing = useSendPing();


  function useSetExtraPings() {
    const [
      pending,
      setPending
    ] = useState<PendingTeamSetExtraPingsRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useSetExtraPings(id, setPending);
      return () => {
        instance.unuseSetExtraPings(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const setExtraPings = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<TeamSetExtraPingsRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof TeamSetExtraPingsRequest
          ? partialRequest.clone()
          : new TeamSetExtraPingsRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.setExtraPings(mutation);
      };

      method.pending =
        new Array<PendingTeamSetExtraPingsRequestMutation>();

      return method;
    }, [bearerToken]);

    setExtraPings.pending = pending;

    return setExtraPings;
  }

  const setExtraPings = useSetExtraPings();


  return {
    mutators: {
      create,
      join,
      addChatId,
      deletePlayer,
      grabObjective,
      removeObjective,
      sendPing,
      setExtraPings,
    },
    create,
    join,
    players,
    usePlayers,
    info,
    useInfo,
    addChatId,
    deletePlayer,
    grabObjective,
    currentObjective,
    useCurrentObjective,
    removeObjective,
    sendPing,
    setExtraPings,
  };
};



export class Team {
  static State = TeamProto;
}
export namespace Team {
  export type State = TeamProto;
}

export interface SettingsParams {
  id: string;
  storeMutationsLocallyInNamespace?: string;
}

class PlayerInstance {

  constructor(id: string, stateRef: string, url: string) {
    this.id = id;
    this.stateRef = stateRef;
    this.url = url;
    this.refs = 1;

     reboot_web.websockets.connect(this.url, this.stateRef);
    this.initializeWebSocket();
  }

  private ref() {
    this.refs += 1;
    return this.refs;
  }

  private unref() {
    this.refs -= 1;

    if (this.refs === 0 && this.websocket !== undefined) {
      this.websocket.close();
       reboot_web.websockets.disconnect(this.url, this.stateRef);
    }

    return this.refs;
  }

  readonly id: string;
  readonly stateRef: string;
  private url: string;
  private refs: number;
  private observers: reboot_react.Observers = {};
  private loadingReaders = 0;
  private runningMutates: reboot_react.Mutate[] = [];
  private queuedMutates: reboot_react.Mutate[] = [];
  private flushMutates?: reboot_api.Event = undefined;
  private websocket?: WebSocket = undefined;
  private backoff: reboot_api.Backoff = new reboot_api.Backoff();

  private hasRunningMutations() {
    return this.runningMutates.length > 0;
  }

  private async flushMutations() {
    if (this.flushMutates === undefined) {
      this.flushMutates = new reboot_api.Event();
    }
    await this.flushMutates.wait();
  }

  private readersLoadedOrFailed() {
    this.flushMutates = undefined;

    if (this.queuedMutates.length > 0) {
      this.runningMutates = this.queuedMutates;
      this.queuedMutates = [];

      if (this.websocket?.readyState === WebSocket.OPEN) {
        for (const { request, update } of this.runningMutates) {
          update({ isLoading: true });
          try {
            this.websocket.send(request.toBinary());
          } catch {
            // We'll retry since we've stored in `*Mutates`.
          }
        }
      }
    }
  }

  private initializeWebSocket() {
    if (this.websocket === undefined && this.refs > 0) {
      const url = new URL(`${this.url}/__/reboot/rpc/${this.stateRef}`);
      url.protocol = url.protocol === "https:" ? "wss:" : "ws:";

      this.websocket = reboot_web.websockets.create(url);

      this.websocket.binaryType = "arraybuffer";

      this.websocket.onopen = () => {
        if (this.websocket?.readyState === WebSocket.OPEN) {
          for (const { request, update } of this.runningMutates) {
            update({ isLoading: true });
            try {
              this.websocket.send(request.toBinary());
            } catch {
              // We'll retry since we've stored in `*Mutates`.
            }
          }
        }
      };

      this.websocket.onerror = async () => {
        if (this.websocket !== undefined) {
          this.websocket = undefined;

          for (const { update } of this.runningMutates) {
            update({ isLoading: false, error: "WebSocket disconnected" });
          }

          if (this.refs > 0) {
            if (this.runningMutates.length > 0) {
              console.warn(
                `WebSocket disconnected, ${this.runningMutates.length} outstanding mutations will be retried when we reconnect`
              );
            }

            await this.backoff.wait();

            this.initializeWebSocket();
          }
        }
      };

      this.websocket.onclose = async () => {
        if (this.websocket !== undefined) {
          this.websocket = undefined;

          for (const { update } of this.runningMutates) {
            update({ isLoading: false, error: "WebSocket disconnected" });
          }

          if (this.refs > 0) {
            await this.backoff.wait();

            this.initializeWebSocket();
          }
        }
      };

      this.websocket.onmessage = async (event) => {
        const { resolve } = this.runningMutates[0];
        this.runningMutates.shift();

        const response = reboot_api.react_pb.MutateResponse.fromBinary(
          new Uint8Array(event.data)
        );

        resolve(response);

        if (
          this.flushMutates !== undefined &&
          this.runningMutates.length === 0
        ) {
          this.flushMutates.set();
        }
      };
    }
  }

  private async mutate(
    partialRequest: __bufbuildProtobufPartialMessage<reboot_api.react_pb.MutateRequest>,
    update: (props: { isLoading: boolean; error?: any }) => void
  ): Promise<reboot_api.react_pb.MutateResponse> {
    const request = partialRequest instanceof reboot_api.react_pb.MutateRequest
      ? partialRequest
      : new reboot_api.react_pb.MutateRequest(partialRequest);

    return new Promise((resolve, _) => {
      if (this.loadingReaders === 0) {
        this.runningMutates = this.runningMutates.concat({ request, resolve, update });
        if (this.websocket?.readyState === WebSocket.OPEN) {
          update({ isLoading: true });
          try {
            this.websocket.send(request.toBinary());
          } catch {
            // We'll retry since we've stored in `*Mutates`.
          }
        }
      } else {
        this.queuedMutates = this.queuedMutates.concat({ request, resolve, update });
      }
    });
  }

  private async read<
    RequestType extends __bufbuildProtobufMessage<RequestType>,
    ResponseType extends __bufbuildProtobufMessage<ResponseType>,
    >(
    method: string,
    request: RequestType,
    bearerToken: string | undefined,
    responseType: __bufbuildProtobufMessageType<ResponseType>,
    reader: reboot_react.Reader<ResponseType>
  ) {
    const queryRequest = new reboot_api.react_pb.QueryRequest({
      method,
      request: request.toBinary(),
      ...(bearerToken !== undefined && { bearerToken } || {}),
    });

    // Expected idempotency key we should observe due to a mutation.
    interface Expected {
      // Idempotency key of mutation.
      idempotencyKey: string;

      // Callback when we've observed this idempotency key.
      observed: (callback: () => void) => Promise<void>;

      // Callback when we no longer care about observing.
      aborted: () => void;
    }

    let expecteds: Expected[] = [];

    // When we disconnect we may not be able to observe
    // responses due to mutations yet there may still be
    // some outstanding responses that are expected which
    // we treat as "orphans" in the sense that we won't
    // observe their idempotency keys but once we reconnect
    // we will still have observed their effects and can
    // call `observed()` on them.
    let orphans: Expected[] = [];

    const id = `${uuidv4()}`;

    this.observers[id] = {
      observe: (
        idempotencyKey: string,
        observed: (callback: () => void) => Promise<void>,
        aborted: () => void
      ) => {
        expecteds = expecteds.concat({ idempotencyKey, observed, aborted })
      },
      unobserve: (idempotencyKey: string) => {
        expecteds = expecteds.filter(
          expected => expected.idempotencyKey !== idempotencyKey
        );
      }
    };

    try {
      await reboot_api.retryForever(async () => {
        let loaded = false;
        this.loadingReaders += 1;

        // Any mutations started after we've incremented
        // `this.loadingReaders` will be queued until after
        // all the readers have loaded and thus (1) we know all
        // current `expected` are actually `orphans` that
        // we will haved "observed" once we are (re)connected
        // because we flush mutations before starting to read
        // and (2) all queued mutations can stay in `expected`
        // because we will in fact be able to observe them
        // since they won't get sent over the websocket
        // until after we are (re)connected.
        //
        // NOTE: we need to concatenate with `orphans`
        // because we may try to (re)connect multiple times
        // and between each try more mutations may have been
        // made (or queued ones will be moved to running).
        orphans = [...orphans, ...expecteds];
        expecteds = [];

        try {
          // Wait for potentially completed mutations to flush
          // before starting to read so that we read the latest
          // state including those mutations.
          if (this.hasRunningMutations()) {
            await this.flushMutations();
          }

          unstable_batchedUpdates(() => {
            for (const setIsLoading of Object.values(reader.setIsLoadings)) {
              setIsLoading(true);
            }
          });

          const queryResponses = reboot_web.reactiveReader({
            endpoint: `${this.url}/__/reboot/rpc/${this.stateRef}`,
            request: queryRequest,
            signal: reader.abortController.signal,
          });

          for await (const queryResponse of queryResponses) {
            if (!loaded) {
              if ((this.loadingReaders -= 1) === 0) {
                this.readersLoadedOrFailed();
              }
              loaded = true;
            }

            unstable_batchedUpdates(() => {
              for (const setIsLoading of Object.values(reader.setIsLoadings)) {
                setIsLoading(false);
              }
            });

            const response = queryResponse.responseOrStatus.case === "response"
              ? responseType.fromBinary(queryResponse.responseOrStatus.value)
              : undefined;

            // If we were disconnected it must be that we've
            // observed all `orphans` because we waited
            // for any mutations to flush before we re-started to
            // read.
            if (orphans.length > 0) {
              // We mark all mutations as observed except the
              // last one which we also invoke all `setResponse`s.
              // In this way we effectively create a barrier
              // for all readers that will synchronize on the last
              // mutation, but note that this still may lead
              // to some partial state/response updates because
              // one reader may have actually received a response
              // while another reader got disconnected. While this
              // is likely very rare, it is possible. Mitigating
              // this issue is non-trivial and for now we have
              // no plans to address it.
              for (let i = 0; i < orphans.length - 1; i++) {
                orphans[i].observed(() => {});
              }
              await orphans[orphans.length - 1].observed(() => {
                if (response !== undefined) {
                  reader.response = response;
                  for (const setResponse of Object.values(reader.setResponses)) {
                    setResponse(response);
                  }
                }
              });

              orphans = [];
            } else if (
              expecteds.length > 0 &&
              queryResponse.idempotencyKeys.includes(
                expecteds[0].idempotencyKey
              )
            ) {
              await expecteds[0].observed(() => {
                if (response !== undefined) {
                  reader.response = response;
                  for (const setResponse of Object.values(reader.setResponses)) {
                    setResponse(response);
                  }
                }
                expecteds.shift();
              });
            } else if (response !== undefined) {
              unstable_batchedUpdates(() => {
                reader.response = response;
                for (const setResponse of Object.values(reader.setResponses)) {
                  setResponse(response);
                }
              });
            }
          }

          throw new Error('Not expecting stream to ever be done');
        } catch (e: unknown) {
          if (!loaded) {
            if ((this.loadingReaders -= 1) === 0) {
              this.readersLoadedOrFailed();
            }
          }

          loaded = false;

          if (reader.abortController.signal.aborted) {
            for (const { aborted } of [...orphans, ...expecteds]) {
              aborted();
            }
            return;
          }

          unstable_batchedUpdates(() => {
            for (const setIsLoading of Object.values(reader.setIsLoadings)) {
              setIsLoading(false);
            }
            for (const setStatus of Object.values(reader.setStatuses)) {
              if (e instanceof reboot_api.Status) {
                setStatus(e);
              } else {
                setStatus(
                  new reboot_api.Status({
                    code: reboot_api.StatusCode.UNKNOWN,
                    message: e instanceof Error
                      ? e.message
                      : JSON.stringify(e),
                  })
                );
              }
            }
          });

          throw e; // This just retries!
        }
      });
    } finally {
      delete this.observers[id];
    }
  }


  private useCreateMutations: (
    PendingPlayerCreateRequestMutation)[] = [];

  private useCreateSetPendings: {
    [id: string]: (mutations: PendingPlayerCreateRequestMutation[]) => void
  } = {};

  async create(
    mutation: PendingPlayerCreateRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      PlayerCreateResponse,
      PlayerCreateAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useCreateMutations = this.useCreateMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useCreateSetPendings)) {
        setPending(this.useCreateMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        PlayerCreateResponse,
        PlayerCreateAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "Create",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useCreateMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useCreateSetPendings)) {
                  setPending(this.useCreateMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useCreateMutations =
            this.useCreateMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useCreateSetPendings)) {
              setPending(this.useCreateMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: PlayerCreateResponse.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = PlayerCreateAborted.fromStatus(status);

            console.warn(
              `'Player.Create' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useCreate(
    id: string,
    setPending: (mutations: PendingPlayerCreateRequestMutation[]) => void
  ) {
    this.useCreateSetPendings[id] = setPending;
  }

  unuseCreate(id: string) {
    delete this.useCreateSetPendings[id];
  }


  private useVisibleInfoReaders: {
    [id: string]: reboot_react.Reader<PlayerVisibleInfoResponse>
  } = {};

  useVisibleInfo(
    id: string,
    request: PlayerVisibleInfoRequest,
    bearerToken: string | undefined,
    setResponse: (response: PlayerVisibleInfoResponse) => void,
    setIsLoading: (isLoading: boolean) => void,
    setStatus: (status: reboot_api.Status) => void
  ) {
    let read = false;

    // NOTE: need to concatenate `request.toJsonString()` with `bearerToken`
    // because it uniquely identifies the request, i.e., a second call
    // that has the same `request` but a different bearerToken should be a
    // different call.
    const key = request.toJsonString() + bearerToken;

    if (!(key in this.useVisibleInfoReaders)) {
      this.useVisibleInfoReaders[key] = {
        abortController: new AbortController(),
        setResponses: {},
        setIsLoadings: {},
        setStatuses: {},
      };

      read = true;
    }

    let reader = this.useVisibleInfoReaders[key];

    reader.setResponses[id] = setResponse;
    reader.setIsLoadings[id] = setIsLoading;
    reader.setStatuses[id] = setStatus;

    if (reader.response !== undefined) {
      setResponse(reader.response);
    }

    if (read) {
      this.read(
        "VisibleInfo",
        request,
        bearerToken,
        PlayerVisibleInfoResponse,
        reader
      );
    }
  }

  unuseVisibleInfo(
    id: string,
    request: PlayerVisibleInfoRequest,
    bearerToken: string | undefined
  ) {
    // See comment above in `useVisibleInfo` for why
    // we concatenate `request.toJsonString()` with `bearerToken`.
    const key = request.toJsonString() + bearerToken;

    const reader = this.useVisibleInfoReaders[key];

    delete reader.setResponses[id];
    delete reader.setIsLoadings[id];
    delete reader.setStatuses[id];

    if (Object.values(reader.setResponses).length === 0) {
      delete this.useVisibleInfoReaders[key];
      reader.abortController.abort();
    }
  }


  private useAddCoordinatesMutations: (
    PendingPlayerAddCoordinatesRequestMutation)[] = [];

  private useAddCoordinatesSetPendings: {
    [id: string]: (mutations: PendingPlayerAddCoordinatesRequestMutation[]) => void
  } = {};

  async addCoordinates(
    mutation: PendingPlayerAddCoordinatesRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      PlayerAddCoordinatesResponse,
      PlayerAddCoordinatesAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useAddCoordinatesMutations = this.useAddCoordinatesMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useAddCoordinatesSetPendings)) {
        setPending(this.useAddCoordinatesMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        PlayerAddCoordinatesResponse,
        PlayerAddCoordinatesAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "AddCoordinates",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useAddCoordinatesMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useAddCoordinatesSetPendings)) {
                  setPending(this.useAddCoordinatesMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useAddCoordinatesMutations =
            this.useAddCoordinatesMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useAddCoordinatesSetPendings)) {
              setPending(this.useAddCoordinatesMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: PlayerAddCoordinatesResponse.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = PlayerAddCoordinatesAborted.fromStatus(status);

            console.warn(
              `'Player.AddCoordinates' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useAddCoordinates(
    id: string,
    setPending: (mutations: PendingPlayerAddCoordinatesRequestMutation[]) => void
  ) {
    this.useAddCoordinatesSetPendings[id] = setPending;
  }

  unuseAddCoordinates(id: string) {
    delete this.useAddCoordinatesSetPendings[id];
  }


  private useCurrentCoordinatesReaders: {
    [id: string]: reboot_react.Reader<PlayerCurrentCoordinatesResponse>
  } = {};

  useCurrentCoordinates(
    id: string,
    request: PlayerCurrentCoordinatesRequest,
    bearerToken: string | undefined,
    setResponse: (response: PlayerCurrentCoordinatesResponse) => void,
    setIsLoading: (isLoading: boolean) => void,
    setStatus: (status: reboot_api.Status) => void
  ) {
    let read = false;

    // NOTE: need to concatenate `request.toJsonString()` with `bearerToken`
    // because it uniquely identifies the request, i.e., a second call
    // that has the same `request` but a different bearerToken should be a
    // different call.
    const key = request.toJsonString() + bearerToken;

    if (!(key in this.useCurrentCoordinatesReaders)) {
      this.useCurrentCoordinatesReaders[key] = {
        abortController: new AbortController(),
        setResponses: {},
        setIsLoadings: {},
        setStatuses: {},
      };

      read = true;
    }

    let reader = this.useCurrentCoordinatesReaders[key];

    reader.setResponses[id] = setResponse;
    reader.setIsLoadings[id] = setIsLoading;
    reader.setStatuses[id] = setStatus;

    if (reader.response !== undefined) {
      setResponse(reader.response);
    }

    if (read) {
      this.read(
        "CurrentCoordinates",
        request,
        bearerToken,
        PlayerCurrentCoordinatesResponse,
        reader
      );
    }
  }

  unuseCurrentCoordinates(
    id: string,
    request: PlayerCurrentCoordinatesRequest,
    bearerToken: string | undefined
  ) {
    // See comment above in `useCurrentCoordinates` for why
    // we concatenate `request.toJsonString()` with `bearerToken`.
    const key = request.toJsonString() + bearerToken;

    const reader = this.useCurrentCoordinatesReaders[key];

    delete reader.setResponses[id];
    delete reader.setIsLoadings[id];
    delete reader.setStatuses[id];

    if (Object.values(reader.setResponses).length === 0) {
      delete this.useCurrentCoordinatesReaders[key];
      reader.abortController.abort();
    }
  }


  private useNameReaders: {
    [id: string]: reboot_react.Reader<PlayerNameResponse>
  } = {};

  useName(
    id: string,
    request: PlayerNameRequest,
    bearerToken: string | undefined,
    setResponse: (response: PlayerNameResponse) => void,
    setIsLoading: (isLoading: boolean) => void,
    setStatus: (status: reboot_api.Status) => void
  ) {
    let read = false;

    // NOTE: need to concatenate `request.toJsonString()` with `bearerToken`
    // because it uniquely identifies the request, i.e., a second call
    // that has the same `request` but a different bearerToken should be a
    // different call.
    const key = request.toJsonString() + bearerToken;

    if (!(key in this.useNameReaders)) {
      this.useNameReaders[key] = {
        abortController: new AbortController(),
        setResponses: {},
        setIsLoadings: {},
        setStatuses: {},
      };

      read = true;
    }

    let reader = this.useNameReaders[key];

    reader.setResponses[id] = setResponse;
    reader.setIsLoadings[id] = setIsLoading;
    reader.setStatuses[id] = setStatus;

    if (reader.response !== undefined) {
      setResponse(reader.response);
    }

    if (read) {
      this.read(
        "Name",
        request,
        bearerToken,
        PlayerNameResponse,
        reader
      );
    }
  }

  unuseName(
    id: string,
    request: PlayerNameRequest,
    bearerToken: string | undefined
  ) {
    // See comment above in `useName` for why
    // we concatenate `request.toJsonString()` with `bearerToken`.
    const key = request.toJsonString() + bearerToken;

    const reader = this.useNameReaders[key];

    delete reader.setResponses[id];
    delete reader.setIsLoadings[id];
    delete reader.setStatuses[id];

    if (Object.values(reader.setResponses).length === 0) {
      delete this.useNameReaders[key];
      reader.abortController.abort();
    }
  }


  private useTeamReaders: {
    [id: string]: reboot_react.Reader<PlayerTeamResponse>
  } = {};

  useTeam(
    id: string,
    request: PlayerTeamRequest,
    bearerToken: string | undefined,
    setResponse: (response: PlayerTeamResponse) => void,
    setIsLoading: (isLoading: boolean) => void,
    setStatus: (status: reboot_api.Status) => void
  ) {
    let read = false;

    // NOTE: need to concatenate `request.toJsonString()` with `bearerToken`
    // because it uniquely identifies the request, i.e., a second call
    // that has the same `request` but a different bearerToken should be a
    // different call.
    const key = request.toJsonString() + bearerToken;

    if (!(key in this.useTeamReaders)) {
      this.useTeamReaders[key] = {
        abortController: new AbortController(),
        setResponses: {},
        setIsLoadings: {},
        setStatuses: {},
      };

      read = true;
    }

    let reader = this.useTeamReaders[key];

    reader.setResponses[id] = setResponse;
    reader.setIsLoadings[id] = setIsLoading;
    reader.setStatuses[id] = setStatus;

    if (reader.response !== undefined) {
      setResponse(reader.response);
    }

    if (read) {
      this.read(
        "Team",
        request,
        bearerToken,
        PlayerTeamResponse,
        reader
      );
    }
  }

  unuseTeam(
    id: string,
    request: PlayerTeamRequest,
    bearerToken: string | undefined
  ) {
    // See comment above in `useTeam` for why
    // we concatenate `request.toJsonString()` with `bearerToken`.
    const key = request.toJsonString() + bearerToken;

    const reader = this.useTeamReaders[key];

    delete reader.setResponses[id];
    delete reader.setIsLoadings[id];
    delete reader.setStatuses[id];

    if (Object.values(reader.setResponses).length === 0) {
      delete this.useTeamReaders[key];
      reader.abortController.abort();
    }
  }


  private useClearStateMutations: (
    PendingEmptyMutation)[] = [];

  private useClearStateSetPendings: {
    [id: string]: (mutations: PendingEmptyMutation[]) => void
  } = {};

  async clearState(
    mutation: PendingEmptyMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      PlayerClearStateAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useClearStateMutations = this.useClearStateMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useClearStateSetPendings)) {
        setPending(this.useClearStateMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        PlayerClearStateAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "ClearState",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useClearStateMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useClearStateSetPendings)) {
                  setPending(this.useClearStateMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useClearStateMutations =
            this.useClearStateMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useClearStateSetPendings)) {
              setPending(this.useClearStateMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = PlayerClearStateAborted.fromStatus(status);

            console.warn(
              `'Player.ClearState' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useClearState(
    id: string,
    setPending: (mutations: PendingEmptyMutation[]) => void
  ) {
    this.useClearStateSetPendings[id] = setPending;
  }

  unuseClearState(id: string) {
    delete this.useClearStateSetPendings[id];
  }


  private useSendPingMutations: (
    PendingEmptyMutation)[] = [];

  private useSendPingSetPendings: {
    [id: string]: (mutations: PendingEmptyMutation[]) => void
  } = {};

  async sendPing(
    mutation: PendingEmptyMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      PlayerSendPingAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useSendPingMutations = this.useSendPingMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useSendPingSetPendings)) {
        setPending(this.useSendPingMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        PlayerSendPingAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "SendPing",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useSendPingMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useSendPingSetPendings)) {
                  setPending(this.useSendPingMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useSendPingMutations =
            this.useSendPingMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useSendPingSetPendings)) {
              setPending(this.useSendPingMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = PlayerSendPingAborted.fromStatus(status);

            console.warn(
              `'Player.SendPing' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useSendPing(
    id: string,
    setPending: (mutations: PendingEmptyMutation[]) => void
  ) {
    this.useSendPingSetPendings[id] = setPending;
  }

  unuseSendPing(id: string) {
    delete this.useSendPingSetPendings[id];
  }


  private static instances: { [id: string]: PlayerInstance } = {};

  static use(id: string, stateRef: string, url: string) {
    if (!(id in this.instances)) {
      this.instances[id] = new PlayerInstance(id, stateRef, url);
    } else {
      this.instances[id].ref();
    }

    return this.instances[id];
  }

  unuse() {
    if (this.unref() === 0) {
      delete PlayerInstance.instances[this.id];
    }
  }
}

export const usePlayer = (
  { id }: { id: string }
): UsePlayerApi => {
  const stateId = id;
  const stateRef = reboot_api.stateIdToRef(
    "copenhunt.v1.Player",
    id,
  );

  const rebootClient = reboot_react.useRebootClient();

  const url = rebootClient.url;
  const bearerToken = rebootClient.bearerToken;

  const [instance, setInstance] = useState(() => {
    return PlayerInstance.use(
      stateId, stateRef, url
    );
  });

  if (instance.id !== stateId) {
    setInstance(
      PlayerInstance.use(
        stateId, stateRef, url
      )
    );
  }

  useEffect(() => {
    return () => {
      instance.unuse();
    };
  }, [instance]);

  const headers = useMemo(() => {
    const headers = new Headers();
    headers.set("Content-Type", "application/json");
    headers.append("Connection", "keep-alive");

    if (bearerToken !== undefined) {
      headers.append("Authorization", `Bearer ${bearerToken}`);
    }

    return headers;
  }, [bearerToken]);


  function useCreate() {
    const [
      pending,
      setPending
    ] = useState<PendingPlayerCreateRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useCreate(id, setPending);
      return () => {
        instance.unuseCreate(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const create = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<PlayerCreateRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof PlayerCreateRequest
          ? partialRequest.clone()
          : new PlayerCreateRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.create(mutation);
      };

      method.pending =
        new Array<PendingPlayerCreateRequestMutation>();

      return method;
    }, [bearerToken]);

    create.pending = pending;

    return create;
  }

  const create = useCreate();



  function useVisibleInfo(
    partialRequest: __bufbuildProtobufPartialMessage<PlayerVisibleInfoRequest> = {}
  ) {
    const newRequest = partialRequest instanceof PlayerVisibleInfoRequest
      ? partialRequest.clone()
      : new PlayerVisibleInfoRequest(partialRequest);

    const [request, setRequest] = useState(newRequest);

    if (!request.equals(newRequest)) {
      setRequest(newRequest);
    }

    const [response, setResponse] = useState<PlayerVisibleInfoResponse>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [aborted, setAborted] = useState<
      undefined
      | PlayerVisibleInfoAborted
      >();

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    useEffect(() => {
      const id = uuidv4();
      instance.useVisibleInfo(
        id,
        request,
        bearerToken,
        (response: PlayerVisibleInfoResponse) => {
          unstable_batchedUpdates(() => {
            setAborted(undefined);
            setResponse(response);
          });
        },
        setIsLoading,
        (status: reboot_api.Status) => {
          const aborted = PlayerVisibleInfoAborted.fromStatus(status);

          console.warn(
            `'Player.VisibleInfo' aborted with ${aborted.message}`
          );

          setAborted(aborted);
        },
      );
      return () => {
        instance.unuseVisibleInfo(id, request, bearerToken);
      };
    }, [request, bearerToken]);

    return { response, isLoading, aborted };
  }

  async function visibleInfo(
    partialRequest: __bufbuildProtobufPartialMessage<PlayerVisibleInfoRequest> = {},
    options?: { signal?: AbortSignal }
  ) {
    const request = partialRequest instanceof PlayerVisibleInfoRequest
      ? partialRequest.clone()
      : new PlayerVisibleInfoRequest(partialRequest);

    // Fetch with retry, using a backoff, i.e., if we get disconnected.
    const { response, aborted } = await (async () => {
      const backoff = new reboot_api.Backoff();

      while (true) {
        try {
          // Invariant here is that we use the '/package.service.method' path and
          // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
          //
          // See also 'reboot/helpers.py'.
          return {
            response: await reboot_web.guardedFetch(
              new Request(
                `${rebootClient.url}/__/reboot/rpc/${stateRef}/copenhunt.v1.PlayerMethods/VisibleInfo`, {
                  method: "POST",
                  headers,
                  body: request.toJsonString()
                }
              ),
              options
            )
          };
        } catch (e: unknown) {
          if (options?.signal?.aborted) {
            const aborted = new PlayerVisibleInfoAborted(
              new reboot_api.errors_pb.Aborted(), {
                message: e instanceof Error
                  ? `${e}`
                  : `Unknown error: ${JSON.stringify(e)}`
              }
            );

            return { aborted };
          } else if (e instanceof Error) {
            console.error(e);
          } else {
            console.error(`Unknown error: ${JSON.stringify(e)}`);
          }
        }

        console.warn(`Retrying call to copenhunt.v1.PlayerMethods.VisibleInfo after backoff ...`);

        await backoff.wait();
      }
    })();

    if (aborted) {
      return { aborted };
    } else if (!response.ok) {
      if (response.headers.get("content-type") === "application/json") {
        const status = reboot_api.Status.fromJson(await response.json());

        const aborted = PlayerVisibleInfoAborted.fromStatus(status);

        console.warn(
          `'Player.VisibleInfo' aborted with ${aborted.message}`
        );

        return { aborted };
      } else {
        const aborted = new PlayerVisibleInfoAborted(
          new reboot_api.errors_pb.Unknown(), {
            message: `Unknown error with HTTP status ${response.status}`
          }
        );

        return { aborted };
      }
    } else {
      return { response: PlayerVisibleInfoResponse.fromJson(await response.json()) };
    }
  }


  function useAddCoordinates() {
    const [
      pending,
      setPending
    ] = useState<PendingPlayerAddCoordinatesRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useAddCoordinates(id, setPending);
      return () => {
        instance.unuseAddCoordinates(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const addCoordinates = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<PlayerAddCoordinatesRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof PlayerAddCoordinatesRequest
          ? partialRequest.clone()
          : new PlayerAddCoordinatesRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.addCoordinates(mutation);
      };

      method.pending =
        new Array<PendingPlayerAddCoordinatesRequestMutation>();

      return method;
    }, [bearerToken]);

    addCoordinates.pending = pending;

    return addCoordinates;
  }

  const addCoordinates = useAddCoordinates();



  function useCurrentCoordinates(
    partialRequest: __bufbuildProtobufPartialMessage<PlayerCurrentCoordinatesRequest> = {}
  ) {
    const newRequest = partialRequest instanceof PlayerCurrentCoordinatesRequest
      ? partialRequest.clone()
      : new PlayerCurrentCoordinatesRequest(partialRequest);

    const [request, setRequest] = useState(newRequest);

    if (!request.equals(newRequest)) {
      setRequest(newRequest);
    }

    const [response, setResponse] = useState<PlayerCurrentCoordinatesResponse>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [aborted, setAborted] = useState<
      undefined
      | PlayerCurrentCoordinatesAborted
      >();

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    useEffect(() => {
      const id = uuidv4();
      instance.useCurrentCoordinates(
        id,
        request,
        bearerToken,
        (response: PlayerCurrentCoordinatesResponse) => {
          unstable_batchedUpdates(() => {
            setAborted(undefined);
            setResponse(response);
          });
        },
        setIsLoading,
        (status: reboot_api.Status) => {
          const aborted = PlayerCurrentCoordinatesAborted.fromStatus(status);

          console.warn(
            `'Player.CurrentCoordinates' aborted with ${aborted.message}`
          );

          setAborted(aborted);
        },
      );
      return () => {
        instance.unuseCurrentCoordinates(id, request, bearerToken);
      };
    }, [request, bearerToken]);

    return { response, isLoading, aborted };
  }

  async function currentCoordinates(
    partialRequest: __bufbuildProtobufPartialMessage<PlayerCurrentCoordinatesRequest> = {},
    options?: { signal?: AbortSignal }
  ) {
    const request = partialRequest instanceof PlayerCurrentCoordinatesRequest
      ? partialRequest.clone()
      : new PlayerCurrentCoordinatesRequest(partialRequest);

    // Fetch with retry, using a backoff, i.e., if we get disconnected.
    const { response, aborted } = await (async () => {
      const backoff = new reboot_api.Backoff();

      while (true) {
        try {
          // Invariant here is that we use the '/package.service.method' path and
          // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
          //
          // See also 'reboot/helpers.py'.
          return {
            response: await reboot_web.guardedFetch(
              new Request(
                `${rebootClient.url}/__/reboot/rpc/${stateRef}/copenhunt.v1.PlayerMethods/CurrentCoordinates`, {
                  method: "POST",
                  headers,
                  body: request.toJsonString()
                }
              ),
              options
            )
          };
        } catch (e: unknown) {
          if (options?.signal?.aborted) {
            const aborted = new PlayerCurrentCoordinatesAborted(
              new reboot_api.errors_pb.Aborted(), {
                message: e instanceof Error
                  ? `${e}`
                  : `Unknown error: ${JSON.stringify(e)}`
              }
            );

            return { aborted };
          } else if (e instanceof Error) {
            console.error(e);
          } else {
            console.error(`Unknown error: ${JSON.stringify(e)}`);
          }
        }

        console.warn(`Retrying call to copenhunt.v1.PlayerMethods.CurrentCoordinates after backoff ...`);

        await backoff.wait();
      }
    })();

    if (aborted) {
      return { aborted };
    } else if (!response.ok) {
      if (response.headers.get("content-type") === "application/json") {
        const status = reboot_api.Status.fromJson(await response.json());

        const aborted = PlayerCurrentCoordinatesAborted.fromStatus(status);

        console.warn(
          `'Player.CurrentCoordinates' aborted with ${aborted.message}`
        );

        return { aborted };
      } else {
        const aborted = new PlayerCurrentCoordinatesAborted(
          new reboot_api.errors_pb.Unknown(), {
            message: `Unknown error with HTTP status ${response.status}`
          }
        );

        return { aborted };
      }
    } else {
      return { response: PlayerCurrentCoordinatesResponse.fromJson(await response.json()) };
    }
  }



  function useName(
    partialRequest: __bufbuildProtobufPartialMessage<PlayerNameRequest> = {}
  ) {
    const newRequest = partialRequest instanceof PlayerNameRequest
      ? partialRequest.clone()
      : new PlayerNameRequest(partialRequest);

    const [request, setRequest] = useState(newRequest);

    if (!request.equals(newRequest)) {
      setRequest(newRequest);
    }

    const [response, setResponse] = useState<PlayerNameResponse>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [aborted, setAborted] = useState<
      undefined
      | PlayerNameAborted
      >();

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    useEffect(() => {
      const id = uuidv4();
      instance.useName(
        id,
        request,
        bearerToken,
        (response: PlayerNameResponse) => {
          unstable_batchedUpdates(() => {
            setAborted(undefined);
            setResponse(response);
          });
        },
        setIsLoading,
        (status: reboot_api.Status) => {
          const aborted = PlayerNameAborted.fromStatus(status);

          console.warn(
            `'Player.Name' aborted with ${aborted.message}`
          );

          setAborted(aborted);
        },
      );
      return () => {
        instance.unuseName(id, request, bearerToken);
      };
    }, [request, bearerToken]);

    return { response, isLoading, aborted };
  }

  async function name(
    partialRequest: __bufbuildProtobufPartialMessage<PlayerNameRequest> = {},
    options?: { signal?: AbortSignal }
  ) {
    const request = partialRequest instanceof PlayerNameRequest
      ? partialRequest.clone()
      : new PlayerNameRequest(partialRequest);

    // Fetch with retry, using a backoff, i.e., if we get disconnected.
    const { response, aborted } = await (async () => {
      const backoff = new reboot_api.Backoff();

      while (true) {
        try {
          // Invariant here is that we use the '/package.service.method' path and
          // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
          //
          // See also 'reboot/helpers.py'.
          return {
            response: await reboot_web.guardedFetch(
              new Request(
                `${rebootClient.url}/__/reboot/rpc/${stateRef}/copenhunt.v1.PlayerMethods/Name`, {
                  method: "POST",
                  headers,
                  body: request.toJsonString()
                }
              ),
              options
            )
          };
        } catch (e: unknown) {
          if (options?.signal?.aborted) {
            const aborted = new PlayerNameAborted(
              new reboot_api.errors_pb.Aborted(), {
                message: e instanceof Error
                  ? `${e}`
                  : `Unknown error: ${JSON.stringify(e)}`
              }
            );

            return { aborted };
          } else if (e instanceof Error) {
            console.error(e);
          } else {
            console.error(`Unknown error: ${JSON.stringify(e)}`);
          }
        }

        console.warn(`Retrying call to copenhunt.v1.PlayerMethods.Name after backoff ...`);

        await backoff.wait();
      }
    })();

    if (aborted) {
      return { aborted };
    } else if (!response.ok) {
      if (response.headers.get("content-type") === "application/json") {
        const status = reboot_api.Status.fromJson(await response.json());

        const aborted = PlayerNameAborted.fromStatus(status);

        console.warn(
          `'Player.Name' aborted with ${aborted.message}`
        );

        return { aborted };
      } else {
        const aborted = new PlayerNameAborted(
          new reboot_api.errors_pb.Unknown(), {
            message: `Unknown error with HTTP status ${response.status}`
          }
        );

        return { aborted };
      }
    } else {
      return { response: PlayerNameResponse.fromJson(await response.json()) };
    }
  }



  function useTeam(
    partialRequest: __bufbuildProtobufPartialMessage<PlayerTeamRequest> = {}
  ) {
    const newRequest = partialRequest instanceof PlayerTeamRequest
      ? partialRequest.clone()
      : new PlayerTeamRequest(partialRequest);

    const [request, setRequest] = useState(newRequest);

    if (!request.equals(newRequest)) {
      setRequest(newRequest);
    }

    const [response, setResponse] = useState<PlayerTeamResponse>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [aborted, setAborted] = useState<
      undefined
      | PlayerTeamAborted
      >();

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    useEffect(() => {
      const id = uuidv4();
      instance.useTeam(
        id,
        request,
        bearerToken,
        (response: PlayerTeamResponse) => {
          unstable_batchedUpdates(() => {
            setAborted(undefined);
            setResponse(response);
          });
        },
        setIsLoading,
        (status: reboot_api.Status) => {
          const aborted = PlayerTeamAborted.fromStatus(status);

          console.warn(
            `'Player.Team' aborted with ${aborted.message}`
          );

          setAborted(aborted);
        },
      );
      return () => {
        instance.unuseTeam(id, request, bearerToken);
      };
    }, [request, bearerToken]);

    return { response, isLoading, aborted };
  }

  async function team(
    partialRequest: __bufbuildProtobufPartialMessage<PlayerTeamRequest> = {},
    options?: { signal?: AbortSignal }
  ) {
    const request = partialRequest instanceof PlayerTeamRequest
      ? partialRequest.clone()
      : new PlayerTeamRequest(partialRequest);

    // Fetch with retry, using a backoff, i.e., if we get disconnected.
    const { response, aborted } = await (async () => {
      const backoff = new reboot_api.Backoff();

      while (true) {
        try {
          // Invariant here is that we use the '/package.service.method' path and
          // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
          //
          // See also 'reboot/helpers.py'.
          return {
            response: await reboot_web.guardedFetch(
              new Request(
                `${rebootClient.url}/__/reboot/rpc/${stateRef}/copenhunt.v1.PlayerMethods/Team`, {
                  method: "POST",
                  headers,
                  body: request.toJsonString()
                }
              ),
              options
            )
          };
        } catch (e: unknown) {
          if (options?.signal?.aborted) {
            const aborted = new PlayerTeamAborted(
              new reboot_api.errors_pb.Aborted(), {
                message: e instanceof Error
                  ? `${e}`
                  : `Unknown error: ${JSON.stringify(e)}`
              }
            );

            return { aborted };
          } else if (e instanceof Error) {
            console.error(e);
          } else {
            console.error(`Unknown error: ${JSON.stringify(e)}`);
          }
        }

        console.warn(`Retrying call to copenhunt.v1.PlayerMethods.Team after backoff ...`);

        await backoff.wait();
      }
    })();

    if (aborted) {
      return { aborted };
    } else if (!response.ok) {
      if (response.headers.get("content-type") === "application/json") {
        const status = reboot_api.Status.fromJson(await response.json());

        const aborted = PlayerTeamAborted.fromStatus(status);

        console.warn(
          `'Player.Team' aborted with ${aborted.message}`
        );

        return { aborted };
      } else {
        const aborted = new PlayerTeamAborted(
          new reboot_api.errors_pb.Unknown(), {
            message: `Unknown error with HTTP status ${response.status}`
          }
        );

        return { aborted };
      }
    } else {
      return { response: PlayerTeamResponse.fromJson(await response.json()) };
    }
  }


  function useClearState() {
    const [
      pending,
      setPending
    ] = useState<PendingEmptyMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useClearState(id, setPending);
      return () => {
        instance.unuseClearState(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const clearState = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<Empty> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof Empty
          ? partialRequest.clone()
          : new Empty(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.clearState(mutation);
      };

      method.pending =
        new Array<PendingEmptyMutation>();

      return method;
    }, [bearerToken]);

    clearState.pending = pending;

    return clearState;
  }

  const clearState = useClearState();


  function useSendPing() {
    const [
      pending,
      setPending
    ] = useState<PendingEmptyMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useSendPing(id, setPending);
      return () => {
        instance.unuseSendPing(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const sendPing = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<Empty> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof Empty
          ? partialRequest.clone()
          : new Empty(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.sendPing(mutation);
      };

      method.pending =
        new Array<PendingEmptyMutation>();

      return method;
    }, [bearerToken]);

    sendPing.pending = pending;

    return sendPing;
  }

  const sendPing = useSendPing();


  return {
    mutators: {
      create,
      addCoordinates,
      clearState,
      sendPing,
    },
    create,
    visibleInfo,
    useVisibleInfo,
    addCoordinates,
    currentCoordinates,
    useCurrentCoordinates,
    name,
    useName,
    team,
    useTeam,
    clearState,
    sendPing,
  };
};



export class Player {
  static State = PlayerProto;
}
export namespace Player {
  export type State = PlayerProto;
}

export interface SettingsParams {
  id: string;
  storeMutationsLocallyInNamespace?: string;
}

class LocationInstance {

  constructor(id: string, stateRef: string, url: string) {
    this.id = id;
    this.stateRef = stateRef;
    this.url = url;
    this.refs = 1;

     reboot_web.websockets.connect(this.url, this.stateRef);
    this.initializeWebSocket();
  }

  private ref() {
    this.refs += 1;
    return this.refs;
  }

  private unref() {
    this.refs -= 1;

    if (this.refs === 0 && this.websocket !== undefined) {
      this.websocket.close();
       reboot_web.websockets.disconnect(this.url, this.stateRef);
    }

    return this.refs;
  }

  readonly id: string;
  readonly stateRef: string;
  private url: string;
  private refs: number;
  private observers: reboot_react.Observers = {};
  private loadingReaders = 0;
  private runningMutates: reboot_react.Mutate[] = [];
  private queuedMutates: reboot_react.Mutate[] = [];
  private flushMutates?: reboot_api.Event = undefined;
  private websocket?: WebSocket = undefined;
  private backoff: reboot_api.Backoff = new reboot_api.Backoff();

  private hasRunningMutations() {
    return this.runningMutates.length > 0;
  }

  private async flushMutations() {
    if (this.flushMutates === undefined) {
      this.flushMutates = new reboot_api.Event();
    }
    await this.flushMutates.wait();
  }

  private readersLoadedOrFailed() {
    this.flushMutates = undefined;

    if (this.queuedMutates.length > 0) {
      this.runningMutates = this.queuedMutates;
      this.queuedMutates = [];

      if (this.websocket?.readyState === WebSocket.OPEN) {
        for (const { request, update } of this.runningMutates) {
          update({ isLoading: true });
          try {
            this.websocket.send(request.toBinary());
          } catch {
            // We'll retry since we've stored in `*Mutates`.
          }
        }
      }
    }
  }

  private initializeWebSocket() {
    if (this.websocket === undefined && this.refs > 0) {
      const url = new URL(`${this.url}/__/reboot/rpc/${this.stateRef}`);
      url.protocol = url.protocol === "https:" ? "wss:" : "ws:";

      this.websocket = reboot_web.websockets.create(url);

      this.websocket.binaryType = "arraybuffer";

      this.websocket.onopen = () => {
        if (this.websocket?.readyState === WebSocket.OPEN) {
          for (const { request, update } of this.runningMutates) {
            update({ isLoading: true });
            try {
              this.websocket.send(request.toBinary());
            } catch {
              // We'll retry since we've stored in `*Mutates`.
            }
          }
        }
      };

      this.websocket.onerror = async () => {
        if (this.websocket !== undefined) {
          this.websocket = undefined;

          for (const { update } of this.runningMutates) {
            update({ isLoading: false, error: "WebSocket disconnected" });
          }

          if (this.refs > 0) {
            if (this.runningMutates.length > 0) {
              console.warn(
                `WebSocket disconnected, ${this.runningMutates.length} outstanding mutations will be retried when we reconnect`
              );
            }

            await this.backoff.wait();

            this.initializeWebSocket();
          }
        }
      };

      this.websocket.onclose = async () => {
        if (this.websocket !== undefined) {
          this.websocket = undefined;

          for (const { update } of this.runningMutates) {
            update({ isLoading: false, error: "WebSocket disconnected" });
          }

          if (this.refs > 0) {
            await this.backoff.wait();

            this.initializeWebSocket();
          }
        }
      };

      this.websocket.onmessage = async (event) => {
        const { resolve } = this.runningMutates[0];
        this.runningMutates.shift();

        const response = reboot_api.react_pb.MutateResponse.fromBinary(
          new Uint8Array(event.data)
        );

        resolve(response);

        if (
          this.flushMutates !== undefined &&
          this.runningMutates.length === 0
        ) {
          this.flushMutates.set();
        }
      };
    }
  }

  private async mutate(
    partialRequest: __bufbuildProtobufPartialMessage<reboot_api.react_pb.MutateRequest>,
    update: (props: { isLoading: boolean; error?: any }) => void
  ): Promise<reboot_api.react_pb.MutateResponse> {
    const request = partialRequest instanceof reboot_api.react_pb.MutateRequest
      ? partialRequest
      : new reboot_api.react_pb.MutateRequest(partialRequest);

    return new Promise((resolve, _) => {
      if (this.loadingReaders === 0) {
        this.runningMutates = this.runningMutates.concat({ request, resolve, update });
        if (this.websocket?.readyState === WebSocket.OPEN) {
          update({ isLoading: true });
          try {
            this.websocket.send(request.toBinary());
          } catch {
            // We'll retry since we've stored in `*Mutates`.
          }
        }
      } else {
        this.queuedMutates = this.queuedMutates.concat({ request, resolve, update });
      }
    });
  }

  private async read<
    RequestType extends __bufbuildProtobufMessage<RequestType>,
    ResponseType extends __bufbuildProtobufMessage<ResponseType>,
    >(
    method: string,
    request: RequestType,
    bearerToken: string | undefined,
    responseType: __bufbuildProtobufMessageType<ResponseType>,
    reader: reboot_react.Reader<ResponseType>
  ) {
    const queryRequest = new reboot_api.react_pb.QueryRequest({
      method,
      request: request.toBinary(),
      ...(bearerToken !== undefined && { bearerToken } || {}),
    });

    // Expected idempotency key we should observe due to a mutation.
    interface Expected {
      // Idempotency key of mutation.
      idempotencyKey: string;

      // Callback when we've observed this idempotency key.
      observed: (callback: () => void) => Promise<void>;

      // Callback when we no longer care about observing.
      aborted: () => void;
    }

    let expecteds: Expected[] = [];

    // When we disconnect we may not be able to observe
    // responses due to mutations yet there may still be
    // some outstanding responses that are expected which
    // we treat as "orphans" in the sense that we won't
    // observe their idempotency keys but once we reconnect
    // we will still have observed their effects and can
    // call `observed()` on them.
    let orphans: Expected[] = [];

    const id = `${uuidv4()}`;

    this.observers[id] = {
      observe: (
        idempotencyKey: string,
        observed: (callback: () => void) => Promise<void>,
        aborted: () => void
      ) => {
        expecteds = expecteds.concat({ idempotencyKey, observed, aborted })
      },
      unobserve: (idempotencyKey: string) => {
        expecteds = expecteds.filter(
          expected => expected.idempotencyKey !== idempotencyKey
        );
      }
    };

    try {
      await reboot_api.retryForever(async () => {
        let loaded = false;
        this.loadingReaders += 1;

        // Any mutations started after we've incremented
        // `this.loadingReaders` will be queued until after
        // all the readers have loaded and thus (1) we know all
        // current `expected` are actually `orphans` that
        // we will haved "observed" once we are (re)connected
        // because we flush mutations before starting to read
        // and (2) all queued mutations can stay in `expected`
        // because we will in fact be able to observe them
        // since they won't get sent over the websocket
        // until after we are (re)connected.
        //
        // NOTE: we need to concatenate with `orphans`
        // because we may try to (re)connect multiple times
        // and between each try more mutations may have been
        // made (or queued ones will be moved to running).
        orphans = [...orphans, ...expecteds];
        expecteds = [];

        try {
          // Wait for potentially completed mutations to flush
          // before starting to read so that we read the latest
          // state including those mutations.
          if (this.hasRunningMutations()) {
            await this.flushMutations();
          }

          unstable_batchedUpdates(() => {
            for (const setIsLoading of Object.values(reader.setIsLoadings)) {
              setIsLoading(true);
            }
          });

          const queryResponses = reboot_web.reactiveReader({
            endpoint: `${this.url}/__/reboot/rpc/${this.stateRef}`,
            request: queryRequest,
            signal: reader.abortController.signal,
          });

          for await (const queryResponse of queryResponses) {
            if (!loaded) {
              if ((this.loadingReaders -= 1) === 0) {
                this.readersLoadedOrFailed();
              }
              loaded = true;
            }

            unstable_batchedUpdates(() => {
              for (const setIsLoading of Object.values(reader.setIsLoadings)) {
                setIsLoading(false);
              }
            });

            const response = queryResponse.responseOrStatus.case === "response"
              ? responseType.fromBinary(queryResponse.responseOrStatus.value)
              : undefined;

            // If we were disconnected it must be that we've
            // observed all `orphans` because we waited
            // for any mutations to flush before we re-started to
            // read.
            if (orphans.length > 0) {
              // We mark all mutations as observed except the
              // last one which we also invoke all `setResponse`s.
              // In this way we effectively create a barrier
              // for all readers that will synchronize on the last
              // mutation, but note that this still may lead
              // to some partial state/response updates because
              // one reader may have actually received a response
              // while another reader got disconnected. While this
              // is likely very rare, it is possible. Mitigating
              // this issue is non-trivial and for now we have
              // no plans to address it.
              for (let i = 0; i < orphans.length - 1; i++) {
                orphans[i].observed(() => {});
              }
              await orphans[orphans.length - 1].observed(() => {
                if (response !== undefined) {
                  reader.response = response;
                  for (const setResponse of Object.values(reader.setResponses)) {
                    setResponse(response);
                  }
                }
              });

              orphans = [];
            } else if (
              expecteds.length > 0 &&
              queryResponse.idempotencyKeys.includes(
                expecteds[0].idempotencyKey
              )
            ) {
              await expecteds[0].observed(() => {
                if (response !== undefined) {
                  reader.response = response;
                  for (const setResponse of Object.values(reader.setResponses)) {
                    setResponse(response);
                  }
                }
                expecteds.shift();
              });
            } else if (response !== undefined) {
              unstable_batchedUpdates(() => {
                reader.response = response;
                for (const setResponse of Object.values(reader.setResponses)) {
                  setResponse(response);
                }
              });
            }
          }

          throw new Error('Not expecting stream to ever be done');
        } catch (e: unknown) {
          if (!loaded) {
            if ((this.loadingReaders -= 1) === 0) {
              this.readersLoadedOrFailed();
            }
          }

          loaded = false;

          if (reader.abortController.signal.aborted) {
            for (const { aborted } of [...orphans, ...expecteds]) {
              aborted();
            }
            return;
          }

          unstable_batchedUpdates(() => {
            for (const setIsLoading of Object.values(reader.setIsLoadings)) {
              setIsLoading(false);
            }
            for (const setStatus of Object.values(reader.setStatuses)) {
              if (e instanceof reboot_api.Status) {
                setStatus(e);
              } else {
                setStatus(
                  new reboot_api.Status({
                    code: reboot_api.StatusCode.UNKNOWN,
                    message: e instanceof Error
                      ? e.message
                      : JSON.stringify(e),
                  })
                );
              }
            }
          });

          throw e; // This just retries!
        }
      });
    } finally {
      delete this.observers[id];
    }
  }


  private useSetMutations: (
    PendingLocationSetRequestMutation)[] = [];

  private useSetSetPendings: {
    [id: string]: (mutations: PendingLocationSetRequestMutation[]) => void
  } = {};

  async set(
    mutation: PendingLocationSetRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      Empty,
      LocationSetAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useSetMutations = this.useSetMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useSetSetPendings)) {
        setPending(this.useSetMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        Empty,
        LocationSetAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "Set",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useSetMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useSetSetPendings)) {
                  setPending(this.useSetMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useSetMutations =
            this.useSetMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useSetSetPendings)) {
              setPending(this.useSetMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: Empty.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = LocationSetAborted.fromStatus(status);

            console.warn(
              `'Location.Set' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useSet(
    id: string,
    setPending: (mutations: PendingLocationSetRequestMutation[]) => void
  ) {
    this.useSetSetPendings[id] = setPending;
  }

  unuseSet(id: string) {
    delete this.useSetSetPendings[id];
  }


  private useReleaseToTeamMutations: (
    PendingLocationReleaseToTeamRequestMutation)[] = [];

  private useReleaseToTeamSetPendings: {
    [id: string]: (mutations: PendingLocationReleaseToTeamRequestMutation[]) => void
  } = {};

  async releaseToTeam(
    mutation: PendingLocationReleaseToTeamRequestMutation
  ): Promise<
    reboot_web.ResponseOrAborted<
      LocationReleaseToTeamResponse,
      LocationReleaseToTeamAborted
  >> {
    // We always have at least 1 observer which is this function!
    let remainingObservers = 1;

    const event = new reboot_api.Event();

    let callbacks: (() => void)[] = [];

    const observed = (callback: () => void) => {
      callbacks = callbacks.concat(callback);
      remainingObservers -= 1;
      if (remainingObservers === 0) {
        unstable_batchedUpdates(() => {
          for (const callback of callbacks) {
            callback();
          }
        });
        event.set();
      }
      return event.wait();
    };

    const aborted = () => {
      observed(() => {});
    }

    // Tell observers about this pending mutation.
    for (const id in this.observers) {
      remainingObservers += 1;
      this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
    }

    this.useReleaseToTeamMutations = this.useReleaseToTeamMutations.concat(mutation);

    unstable_batchedUpdates(() => {
      for (const setPending of Object.values(this.useReleaseToTeamSetPendings)) {
        setPending(this.useReleaseToTeamMutations);
      }
    });

    return new Promise<
      reboot_web.ResponseOrAborted<
        LocationReleaseToTeamResponse,
        LocationReleaseToTeamAborted
      >>(
      async (resolve, reject) => {
        const { responseOrStatus } = await this.mutate(
          {
            method: "ReleaseToTeam",
            request: mutation.request.toBinary(),
            idempotencyKey: mutation.idempotencyKey,
            bearerToken: mutation.bearerToken,
          },
          ({ isLoading, error }: { isLoading: boolean; error?: any }) => {
            let rerender = false;
            for (const m of this.useReleaseToTeamMutations) {
              if (m === mutation) {
                if (m.isLoading !== isLoading) {
                  m.isLoading = isLoading;
                  rerender = true;
                }
                if (error !== undefined && m.error !== error) {
                  m.error = error;
                  rerender = true;
                }
              }
            }

            if (rerender) {
              unstable_batchedUpdates(() => {
                for (const setPending of Object.values(this.useReleaseToTeamSetPendings)) {
                  setPending(this.useReleaseToTeamMutations);
                }
              });
            }
          }
        );

        const removeMutationsAndSetPending = () => {
          this.useReleaseToTeamMutations =
            this.useReleaseToTeamMutations.filter(m => m !== mutation);

          unstable_batchedUpdates(() => {
            for (const setPending of Object.values(this.useReleaseToTeamSetPendings)) {
              setPending(this.useReleaseToTeamMutations);
            }
          });
        }


        switch (responseOrStatus.case) {
          case "response": {
            await observed(() => {
              removeMutationsAndSetPending();
              resolve({
                response: LocationReleaseToTeamResponse.fromBinary(
                  responseOrStatus.value
                )
              });
            });
            break;
          }
          case "status": {
            // Let the observers know they no longer should expect to
            // observe this idempotency key.
            for (const id in this.observers) {
              this.observers[id].unobserve(mutation.idempotencyKey);
            }

            const status = reboot_api.Status.fromJsonString(responseOrStatus.value);

            const aborted = LocationReleaseToTeamAborted.fromStatus(status);

            console.warn(
              `'Location.ReleaseToTeam' aborted with ${aborted.message}`
            );

            removeMutationsAndSetPending();
            resolve({ aborted });

            break;
          }
          default: {
            // TODO(benh): while this is a _really_ fatal error,
            // should we still set `aborted` instead of throwing?
            reject(new Error('Expecting either a response or a status'));
          }
        }
      });
  }

  useReleaseToTeam(
    id: string,
    setPending: (mutations: PendingLocationReleaseToTeamRequestMutation[]) => void
  ) {
    this.useReleaseToTeamSetPendings[id] = setPending;
  }

  unuseReleaseToTeam(id: string) {
    delete this.useReleaseToTeamSetPendings[id];
  }


  private useGetReaders: {
    [id: string]: reboot_react.Reader<LocationProto>
  } = {};

  useGet(
    id: string,
    request: Empty,
    bearerToken: string | undefined,
    setResponse: (response: LocationProto) => void,
    setIsLoading: (isLoading: boolean) => void,
    setStatus: (status: reboot_api.Status) => void
  ) {
    let read = false;

    // NOTE: need to concatenate `request.toJsonString()` with `bearerToken`
    // because it uniquely identifies the request, i.e., a second call
    // that has the same `request` but a different bearerToken should be a
    // different call.
    const key = request.toJsonString() + bearerToken;

    if (!(key in this.useGetReaders)) {
      this.useGetReaders[key] = {
        abortController: new AbortController(),
        setResponses: {},
        setIsLoadings: {},
        setStatuses: {},
      };

      read = true;
    }

    let reader = this.useGetReaders[key];

    reader.setResponses[id] = setResponse;
    reader.setIsLoadings[id] = setIsLoading;
    reader.setStatuses[id] = setStatus;

    if (reader.response !== undefined) {
      setResponse(reader.response);
    }

    if (read) {
      this.read(
        "Get",
        request,
        bearerToken,
        LocationProto,
        reader
      );
    }
  }

  unuseGet(
    id: string,
    request: Empty,
    bearerToken: string | undefined
  ) {
    // See comment above in `useGet` for why
    // we concatenate `request.toJsonString()` with `bearerToken`.
    const key = request.toJsonString() + bearerToken;

    const reader = this.useGetReaders[key];

    delete reader.setResponses[id];
    delete reader.setIsLoadings[id];
    delete reader.setStatuses[id];

    if (Object.values(reader.setResponses).length === 0) {
      delete this.useGetReaders[key];
      reader.abortController.abort();
    }
  }


  private static instances: { [id: string]: LocationInstance } = {};

  static use(id: string, stateRef: string, url: string) {
    if (!(id in this.instances)) {
      this.instances[id] = new LocationInstance(id, stateRef, url);
    } else {
      this.instances[id].ref();
    }

    return this.instances[id];
  }

  unuse() {
    if (this.unref() === 0) {
      delete LocationInstance.instances[this.id];
    }
  }
}

export const useLocation = (
  { id }: { id: string }
): UseLocationApi => {
  const stateId = id;
  const stateRef = reboot_api.stateIdToRef(
    "copenhunt.v1.Location",
    id,
  );

  const rebootClient = reboot_react.useRebootClient();

  const url = rebootClient.url;
  const bearerToken = rebootClient.bearerToken;

  const [instance, setInstance] = useState(() => {
    return LocationInstance.use(
      stateId, stateRef, url
    );
  });

  if (instance.id !== stateId) {
    setInstance(
      LocationInstance.use(
        stateId, stateRef, url
      )
    );
  }

  useEffect(() => {
    return () => {
      instance.unuse();
    };
  }, [instance]);

  const headers = useMemo(() => {
    const headers = new Headers();
    headers.set("Content-Type", "application/json");
    headers.append("Connection", "keep-alive");

    if (bearerToken !== undefined) {
      headers.append("Authorization", `Bearer ${bearerToken}`);
    }

    return headers;
  }, [bearerToken]);


  function useSet() {
    const [
      pending,
      setPending
    ] = useState<PendingLocationSetRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useSet(id, setPending);
      return () => {
        instance.unuseSet(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const set = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<LocationSetRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof LocationSetRequest
          ? partialRequest.clone()
          : new LocationSetRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.set(mutation);
      };

      method.pending =
        new Array<PendingLocationSetRequestMutation>();

      return method;
    }, [bearerToken]);

    set.pending = pending;

    return set;
  }

  const set = useSet();


  function useReleaseToTeam() {
    const [
      pending,
      setPending
    ] = useState<PendingLocationReleaseToTeamRequestMutation[]>([]);

    useEffect(() => {
      const id = uuidv4();
      instance.useReleaseToTeam(id, setPending);
      return () => {
        instance.unuseReleaseToTeam(id);
      };
    }, []);

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    const releaseToTeam = useMemo(() => {
      const method = async (
        partialRequest: __bufbuildProtobufPartialMessage<LocationReleaseToTeamRequest> = {},
        options?: { metadata?: any }
      ) => {
        const request = partialRequest instanceof LocationReleaseToTeamRequest
          ? partialRequest.clone()
          : new LocationReleaseToTeamRequest(partialRequest);

        const idempotencyKey = uuidv4();

        const mutation = {
          request,
          idempotencyKey,
          bearerToken,
          metadata: options?.metadata,
          isLoading: false, // Won't start loading if we're flushing mutations.
        };

        return instance.releaseToTeam(mutation);
      };

      method.pending =
        new Array<PendingLocationReleaseToTeamRequestMutation>();

      return method;
    }, [bearerToken]);

    releaseToTeam.pending = pending;

    return releaseToTeam;
  }

  const releaseToTeam = useReleaseToTeam();



  function useGet(
    partialRequest: __bufbuildProtobufPartialMessage<Empty> = {}
  ) {
    const newRequest = partialRequest instanceof Empty
      ? partialRequest.clone()
      : new Empty(partialRequest);

    const [request, setRequest] = useState(newRequest);

    if (!request.equals(newRequest)) {
      setRequest(newRequest);
    }

    const [response, setResponse] = useState<LocationProto>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [aborted, setAborted] = useState<
      undefined
      | LocationGetAborted
      >();

    const rebootClient = reboot_react.useRebootClient();

    const bearerToken = rebootClient.bearerToken;

    useEffect(() => {
      const id = uuidv4();
      instance.useGet(
        id,
        request,
        bearerToken,
        (response: LocationProto) => {
          unstable_batchedUpdates(() => {
            setAborted(undefined);
            setResponse(response);
          });
        },
        setIsLoading,
        (status: reboot_api.Status) => {
          const aborted = LocationGetAborted.fromStatus(status);

          console.warn(
            `'Location.Get' aborted with ${aborted.message}`
          );

          setAborted(aborted);
        },
      );
      return () => {
        instance.unuseGet(id, request, bearerToken);
      };
    }, [request, bearerToken]);

    return { response, isLoading, aborted };
  }

  async function get(
    partialRequest: __bufbuildProtobufPartialMessage<Empty> = {},
    options?: { signal?: AbortSignal }
  ) {
    const request = partialRequest instanceof Empty
      ? partialRequest.clone()
      : new Empty(partialRequest);

    // Fetch with retry, using a backoff, i.e., if we get disconnected.
    const { response, aborted } = await (async () => {
      const backoff = new reboot_api.Backoff();

      while (true) {
        try {
          // Invariant here is that we use the '/package.service.method' path and
          // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
          //
          // See also 'reboot/helpers.py'.
          return {
            response: await reboot_web.guardedFetch(
              new Request(
                `${rebootClient.url}/__/reboot/rpc/${stateRef}/copenhunt.v1.LocationMethods/Get`, {
                  method: "POST",
                  headers,
                  body: request.toJsonString()
                }
              ),
              options
            )
          };
        } catch (e: unknown) {
          if (options?.signal?.aborted) {
            const aborted = new LocationGetAborted(
              new reboot_api.errors_pb.Aborted(), {
                message: e instanceof Error
                  ? `${e}`
                  : `Unknown error: ${JSON.stringify(e)}`
              }
            );

            return { aborted };
          } else if (e instanceof Error) {
            console.error(e);
          } else {
            console.error(`Unknown error: ${JSON.stringify(e)}`);
          }
        }

        console.warn(`Retrying call to copenhunt.v1.LocationMethods.Get after backoff ...`);

        await backoff.wait();
      }
    })();

    if (aborted) {
      return { aborted };
    } else if (!response.ok) {
      if (response.headers.get("content-type") === "application/json") {
        const status = reboot_api.Status.fromJson(await response.json());

        const aborted = LocationGetAborted.fromStatus(status);

        console.warn(
          `'Location.Get' aborted with ${aborted.message}`
        );

        return { aborted };
      } else {
        const aborted = new LocationGetAborted(
          new reboot_api.errors_pb.Unknown(), {
            message: `Unknown error with HTTP status ${response.status}`
          }
        );

        return { aborted };
      }
    } else {
      return { response: LocationProto.fromJson(await response.json()) };
    }
  }


  return {
    mutators: {
      set,
      releaseToTeam,
    },
    set,
    releaseToTeam,
    get,
    useGet,
  };
};



export class Location {
  static State = LocationProto;
}
export namespace Location {
  export type State = LocationProto;
}

